// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/assets/images/Grupo-6493.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/assets/images/Grupo-6495.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  color: #1a1b1f;
  font-family: Outfit, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
}

h1 {
  margin-top: 20px;
  margin-bottom: 15px;
  font-size: 44px;
  font-weight: 400;
  line-height: 62px;
}

h2 {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 36px;
  font-weight: 400;
  line-height: 50px;
}

h3 {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 30px;
  font-weight: 400;
  line-height: 46px;
}

h4 {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: 400;
  line-height: 38px;
}

h5 {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: 500;
  line-height: 34px;
}

h6 {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
}

p {
  margin-bottom: 10px;
}

a {
  color: #1a1b1f;
  text-decoration: underline;
  transition: opacity .2s;
  display: block;
}

a:hover {
  color: #32343a;
}

a:active {
  color: #43464d;
}

ul {
  margin-top: 20px;
  margin-bottom: 10px;
  padding-left: 40px;
  list-style-type: disc;
}

li {
  margin-bottom: 10px;
}

img {
  display: block;
}

label {
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
}

blockquote {
  border-left: 5px solid #e2e2e2;
  margin-top: 25px;
  margin-bottom: 25px;
  padding: 15px 30px;
  font-size: 20px;
  line-height: 34px;
}

figcaption {
  opacity: 1;
  text-align: center;
  margin-top: 5px;
  font-size: 14px;
  line-height: 26px;
}

.section__courses {
  background-color: #f5f4ee;
  margin-left: 0;
  margin-right: 0;
  padding-top: 40px;
  padding-bottom: 40px;
  position: relative;
}

.section__courses.cc-cta {
  background-color: #f4f4f4;
  padding-left: 80px;
  padding-right: 80px;
}

.center {
  width: 100%;
  max-width: 1224px;
  margin-top: 0;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 0;
  position: static;
}

.center.center__inner {
  max-width: 900px;
}

.center.center__inner.justify-center {
  justify-content: center;
  display: flex;
}

.center.pos-relative {
  -webkit-text-fill-color: inherit;
  background-clip: border-box;
  position: relative;
}

.center.banner__info-container {
  width: 100%;
  display: block;
  position: static;
}

.center.center_form {
  max-width: 1100px;
}

.center.justify-center {
  flex-direction: column;
  align-items: center;
  display: flex;
}

.paragraph-tiny {
  font-size: 12px;
  line-height: 20px;
}

.paragraph-bigger {
  opacity: 1;
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: 400;
  line-height: 34px;
}

.paragraph-bigger.cc-bigger-light {
  opacity: .6;
}

.button {
  color: #fff;
  letter-spacing: 2px;
  text-transform: uppercase;
  background-color: #1a1b1f;
  border-radius: 0;
  padding: 12px 25px;
  font-size: 12px;
  line-height: 20px;
  text-decoration: none;
  transition: background-color .4s, opacity .4s, color .4s;
}

.button:hover {
  color: #fff;
  background-color: #32343a;
}

.button:active {
  background-color: #43464d;
}

.button.cc-jumbo-button {
  padding: 16px 35px;
  font-size: 14px;
  line-height: 26px;
}

.button.cc-contact-us {
  z-index: 5;
  position: relative;
}

.button.cc-white-button {
  color: #202020;
  background-color: #fff;
  padding: 16px 35px;
  font-size: 14px;
  line-height: 26px;
}

.button.cc-white-button:hover {
  background-color: rgba(255, 255, 255, .8);
}

.button.cc-white-button:active {
  background-color: rgba(255, 255, 255, .9);
}

.label {
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
}

.label.cc-blog-date {
  opacity: .6;
  margin-top: 20px;
}

.rich-text {
  width: 70%;
  margin-bottom: 100px;
  margin-left: auto;
  margin-right: auto;
}

.rich-text p {
  opacity: .6;
  margin-top: 15px;
  margin-bottom: 25px;
}

.rich-text figcaption {
  opacity: .6;
}

.rich-text figure {
  margin-top: 25px;
  padding-bottom: 20px;
}

.heading-jumbo {
  text-transform: none;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 64px;
  line-height: 80px;
}

.heading-jumbo-small {
  text-transform: none;
  margin-top: 10px;
  margin-bottom: 15px;
  font-size: 36px;
  font-weight: 400;
  line-height: 50px;
}

.logo-link {
  z-index: 1;
}

.logo-link:hover {
  opacity: .8;
}

.logo-link:active {
  opacity: .7;
}

.menu {
  z-index: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  position: absolute;
  top: 0%;
  bottom: 0%;
  left: 0%;
  right: 0%;
}

.navigation-wrap {
  flex: 1 1;
  justify-content: space-between;
  align-items: center;
  display: flex;
  position: relative;
}

.navigation {
  background-color: rgba(0, 0, 0, 0);
  align-items: center;
  padding: 30px 50px;
  display: flex;
}

.navigation-item {
  opacity: .6;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding-top: 9px;
  padding-bottom: 9px;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
}

.navigation-item:hover {
  opacity: .9;
}

.navigation-item:active {
  opacity: .8;
}

.navigation-item.w--current {
  opacity: 1;
  color: #1a1b1f;
  font-weight: 600;
}

.navigation-item.w--current:hover {
  opacity: .8;
  color: #32343a;
}

.navigation-item.w--current:active {
  opacity: .7;
  color: #32343a;
}

.logo-image {
  display: block;
}

.navigation-items {
  flex: none;
  justify-content: center;
  align-items: center;
  display: flex;
}

.footer-wrap {
  justify-content: center;
  align-items: center;
  padding-top: 70px;
  padding-bottom: 70px;
  display: flex;
}

.webflow-link {
  opacity: .5;
  align-items: center;
  text-decoration: none;
  transition: opacity .4s;
  display: flex;
}

.webflow-link:hover {
  opacity: 1;
}

.webflow-link:active {
  opacity: .8;
}

.webflow-logo-tiny {
  margin-top: -2px;
  margin-right: 8px;
}

.cta-text {
  width: 70%;
  margin-bottom: 35px;
  margin-left: auto;
  margin-right: auto;
}

.cta-wrap {
  text-align: center;
  justify-content: center;
  padding-top: 110px;
  padding-bottom: 120px;
  display: flex;
}

.status-message {
  color: #fff;
  text-align: center;
  background-color: #202020;
  padding: 9px 30px;
  font-size: 14px;
  line-height: 26px;
}

.status-message.cc-error-message {
  background-color: #db4b68;
}

.text-field {
  border: 1px solid #e4e4e4;
  border-radius: 0;
  margin-bottom: 18px;
  padding: 21px 20px;
  font-size: 14px;
  line-height: 26px;
  transition: border-color .4s;
}

.text-field:hover {
  border-color: #e3e6eb;
}

.text-field:active,
.text-field:focus {
  border-color: #43464d;
}

.text-field::placeholder {
  color: rgba(50, 52, 58, .4);
}

.blog-detail-header-wrap {
  width: 70%;
  margin: 60px auto;
}

.detail-header-image {
  width: 100%;
  height: 620px;
  background-image: url('https://d3e54v103j8qbb.cloudfront.net/img/background-image.svg');
  background-position: 0 0;
  background-size: cover;
  margin-bottom: 60px;
  display: block;
}

.detail-header-image.w--current {
  margin-bottom: 60px;
}

.protected-form {
  flex-direction: column;
  display: flex;
}

.protected-wrap {
  justify-content: center;
  padding-top: 90px;
  padding-bottom: 100px;
  display: flex;
}

.protected-heading {
  margin-bottom: 30px;
}

.utility-page-wrap {
  width: 100vw;
  height: 100vh;
  max-height: 100%;
  max-width: 100%;
  color: #fff;
  text-align: center;
  justify-content: center;
  align-items: center;
  padding: 30px;
  display: flex;
}

._404-wrap {
  width: 100%;
  height: 100%;
  background-color: #1a1b1f;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px;
  display: flex;
}

._404-content-wrap {
  margin-bottom: 20px;
}

.section-heading {
  color: #009db7;
  text-align: left;
  letter-spacing: normal;
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 32px;
  font-weight: 700;
  line-height: 44px;
}

.title__center {
  color: #009db7;
  text-align: center;
  letter-spacing: normal;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-top: 0;
  font-size: 32px;
  font-weight: 700;
  line-height: 44px;
}

.title__center.title__docente {
  margin-bottom: 10px;
}

.courses__container {
  width: 100%;
  flex-direction: column;
  padding-top: 40px;
  padding-bottom: 60px;
  display: block;
}

.course-item-box {
  width: 100%;
  height: auto;
  grid-column-gap: 6px;
  grid-row-gap: 6px;
  text-transform: none;
  white-space: normal;
  object-fit: fill;
  background-color: #fff;
  border-radius: 12px;
  flex-direction: column;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 0;
  padding: 30px 60px;
  line-height: 16px;
  display: flex;
  position: relative;
  overflow: visible;
}

.course-list {
  grid-column-gap: 0px;
  grid-row-gap: 15px;
  flex-direction: column;
  justify-content: center;
  display: flex;
}

.modules__item-title {
  margin-top: 0;
  margin-bottom: 0;
  margin-right: 5px;
  font-size: 24px;
}

.modules__subtitle {
  color: #009db7;
  flex: 0 1 auto;
  font-size: 20px;
  font-weight: 800;
  line-height: 24px;
}

.bold-text {
  font-size: 20px;
  font-weight: 800;
  line-height: 36px;
  display: flex;
}

.modules__icon {
  z-index: auto;
  width: 20px;
  height: 20px;
  text-align: left;
  mix-blend-mode: normal;
  object-fit: fill;
  position: absolute;
  top: 32%;
  bottom: 0%;
  left: auto;
  right: 0%;
}

.modules__item-header {
  width: 100%;
  align-items: center;
  display: flex;
  position: relative;
}

.modules__item-content {
  margin-top: 10px;
}

.section__teacher {
  background-color: #f5f4ee;
  justify-content: center;
  padding-top: 60px;
  padding-bottom: 100px;
  display: flex;
  position: relative;
}

.subscribe__module-title {
  color: #fff;
  border: 0 solid #fff;
  margin-bottom: 0;
  font-family: Outfit, sans-serif;
  font-size: 48px;
  font-weight: 800;
}

.body {
  font-family: Outfit, sans-serif;
}

.teacher__container {
  margin-top: 40px;
}

.teacher__grid {
  grid-column-gap: 7px;
  grid-row-gap: 16px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  align-content: stretch;
  justify-content: stretch;
}

.teacher__item {
  width: 272px;
  height: 409px;
  grid-column-gap: 0px;
  grid-row-gap: 10px;
  -webkit-text-fill-color: inherit;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 0 0;
  background-size: auto;
  background-clip: border-box;
  border-radius: 12px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  display: flex;
}

.teacher__uppertitle {
  color: #fff;
  letter-spacing: 0;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
}

.teacher__name {
  color: #fff;
  text-align: left;
  flex: 0 1 auto;
  align-self: auto;
  font-size: 24px;
  font-weight: 800;
  line-height: 36px;
}

.teacher__description {
  color: #fff;
  text-align: left;
  flex-direction: column;
  align-self: auto;
  align-items: center;
  margin-top: 10px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  display: block;
}

.section__dpo {
  background-color: #f4f1e1;
  padding-top: 20px;
  padding-bottom: 20px;
}

.dpo__columns {
  align-items: center;
  display: flex;
}

.dpo__title {
  color: #000;
  text-align: right;
  font-size: 14px;
  font-weight: 800;
  line-height: 20px;
}

.dpo__description {
  color: #000;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
}

.selo__mec {
  width: auto;
  height: auto;
  filter: grayscale();
}

.section__footer {
  background-color: #009db7;
  padding-top: 40px;
  padding-bottom: 40px;
}

.footer_columns {
  align-items: center;
  display: flex;
}

.footer__column-logo {
  display: block;
}

.social__box {
  grid-column-gap: 8px;
  justify-content: flex-start;
  align-items: center;
  text-decoration: none;
  display: flex;
}

.social__box.social__icons {
  grid-column-gap: 18px;
}

.footer__title {
  color: #fff;
  letter-spacing: 2px;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 800;
  text-decoration: none;
}

.footer__text {
  color: #fff;
  font-weight: 800;
  line-height: 24px;
}

.section__footer-am4 {
  background-color: #f4f1e1;
  justify-content: center;
  align-items: center;
  padding-top: 17px;
  padding-bottom: 17px;
  display: flex;
}

.header {
  height: 38px;
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
  display: flex;
}

.header__container {
  justify-content: flex-start;
  align-items: center;
  display: flex;
  position: relative;
}

.header__link {
  color: #009db7;
  -webkit-text-stroke-color: #009db7;
  text-transform: uppercase;
  align-self: auto;
  font-size: 12px;
  font-weight: 600;
  line-height: 14px;
  text-decoration: none;
}

.section__banner {
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  display: flex;
  min-height: 500px;
  position: relative;
  background: #f4f1e1;
}

.section__about {
  background-color: #f4f1e1;
  padding-top: 100px;
  padding-bottom: 90px;
  position: relative;
}

.sidebar {
  z-index: auto;
  flex-direction: column;
  align-items: flex-end;
  display: flex;
  position: fixed;
  top: auto;
  bottom: 2%;
  left: auto;
  right: 2%;
}

.link-block {
  color: #fff;
  background-color: #006a99;
  text-decoration: none;
}

.link-block.subscribe__link {
  grid-column-gap: 15px;
  border-radius: 70px;
  align-items: center;
  padding: 15px 25px;
  display: flex;
}

.whatsapp__link {
  padding-bottom: 5px;
  display: block;
}

.whatsapp_image {
  display: block;
}

.subscribe__side-link {
  font-size: 12px;
  font-weight: 800;
  line-height: 24px;
}

.about__image {
  width: auto;
}

.about__container {
  display: block;
}

.about__columns {
  grid-column-gap: 20px;
  grid-row-gap: 2px;
  justify-content: space-between;
  align-items: flex-start;
  display: flex;
}

.about__column-left {
  clear: none;
  direction: ltr;
  flex-direction: column;
  flex: 1 1;
  order: 0;
  justify-content: flex-start;
  align-self: flex-start;
  align-items: flex-start;
  padding-left: 0;
  display: block;
  top: 0;
}

.about__column-right {
  object-fit: fill;
  flex: 0 1 auto;
  order: 1;
  align-self: flex-start;
}

.default__uupertitle {
  color: #000;
  padding-bottom: 20px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.default__uupertitle.center-text {
  text-align: center;
}

.section__cookies {
  opacity: .95;
  -webkit-backdrop-filter: blur(9px);
  backdrop-filter: blur(9px);
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 20px;
  display: none;
  position: fixed;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: 0%;
}

.cookies__text {
  justify-content: center;
  align-items: flex-start;
  font-size: 14px;
  line-height: 24px;
  display: block;
}

.cookies__container {
  justify-content: space-around;
  align-items: center;
  display: flex;
}

.cookies__button {
  width: auto;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  color: #fff;
  -webkit-text-fill-color: inherit;
  mix-blend-mode: normal;
  background-color: #009db7;
  background-clip: border-box;
  border-radius: 24px;
  flex: 0 1 auto;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  align-items: center;
  padding: 10px 20px;
  font-size: 12px;
  line-height: 14px;
  text-decoration: none;
  display: flex;
}

.cookies__button:hover {
  color: #fff;
}

.cookies__button.button__subscribe-link {
  width: 375px;
  height: 50px;
  border-radius: 70px;
  padding-top: 0;
  padding-bottom: 0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, .2);
}

.cookies__button.button__subscribe-link.subscribe__teacher {
  display: none;
  position: absolute;
  top: -2%;
  bottom: auto;
  left: 36%;
  right: auto;
}

.cookies__button.menu__button {
  letter-spacing: 1px;
  padding: 12px 25px;
  font-weight: 600;
}

.cookies__button.menu__button:hover {
  color: #fff;
}

.form__group {
  margin-bottom: 0;
  padding-top: 5px;
  padding-bottom: 20px;
  position: relative;
}

.form__group.form__group-button {
  justify-content: flex-start;
  align-items: center;
  padding-top: 30px;
  padding-bottom: 30px;
  display: flex;
}

.form__group.form__group-button.form__group__button_banner {
  justify-content: center;
  padding-top: 5px;
  padding-bottom: 0;
}

.form__group.form__group-banner {
  padding-top: 0;
  padding-bottom: 0;
}

.form__label {
  color: #333;
  letter-spacing: 0;
  text-transform: none;
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: 400;
  line-height: 14px;
}

.form__label.form__banner-label {
  font-size: 12px;
  font-weight: 800;
}

.form__input {
  height: 57px;
  border: 0 solid #000;
  border-radius: 10px;
  font-size: 12px;
}

.form__input.form__banner-input {
  height: 45px;
  border-bottom-width: 1px;
  border-radius: 0;
}

.checkbox-label {
  letter-spacing: 0;
  text-transform: none;
  margin-left: 15px;
  font-size: 16px;
  line-height: 24px;
  text-decoration: none;
}

.checkbox-label.checkbox__label-banner {
  font-size: 12px;
  line-height: 16px;
}

.form__check {
  align-items: center;
  display: flex;
}

.submit-button {
  width: 112px;
  height: 38px;
  letter-spacing: 1px;
  background-color: #009db7;
  border-radius: 24px;
  padding-left: 20px;
  padding-right: 20px;
  font-size: 11px;
  font-weight: 800;
  line-height: 14px;
  display: block;
}

.form__grid {
  grid-template-rows: auto;
  grid-template-columns: 1fr .5fr;
}

.form__grid.form__grid-all {
  grid-row-gap: 5px;
  grid-template-columns: 1fr;
}

.banner__menu {
  z-index: 10;
  width: 100%;
  height: auto;
  grid-column-gap: 40px;
  background-color: rgba(0, 0, 0, 0);
  justify-content: flex-start;
  align-items: flex-end;
  margin-top: 50px;
  display: flex;
  position: absolute;
}

.banner__menu_container {
  grid-column-gap: 25px;
  align-self: center;
  align-items: center;
  display: flex;
}

.menu__link {
  color: #fff;
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
  text-decoration: none;
}

.menu__link:hover {
  color: #fff;
}

.banner__info {
  width: 100%;
  justify-content: center;
  align-self: auto;
  align-items: center;
  display: flex;
  position: absolute;
  top: 19%;
  bottom: 0%;
  left: 0%;
  right: auto;
}

.banner__info-uppertitle {
  width: auto;
  float: none;
  clear: none;
  color: #000;
  letter-spacing: 2px;
  text-transform: uppercase;
  column-count: auto;
  white-space: normal;
  -webkit-text-fill-color: inherit;
  object-fit: fill;
  background-color: rgba(0, 0, 0, 0);
  background-clip: border-box;
  border: 0 #fff;
  border-radius: 0;
  margin-left: auto;
  margin-right: auto;
  padding: 0;
  font-size: 10px;
  font-weight: 800;
  line-height: 10px;
  display: inline-block;
  overflow: visible;
}

.banner__info-uppertitle.banner-info-dates {
  color: #009db7;
  background-color: #fff;
  margin-left: 0;
  margin-right: 0;
  font-weight: 400;
  display: block;
}

.banner__info-uppertitle.banner-info-dates.info-transparent {
  color: #fff;
  background-color: rgba(0, 0, 0, 0);
}

.banner__info-uppertitle.text-center {
  text-align: center;
}

.banner__info-title {
  color: #000;
  padding-top: 0;
  padding-bottom: 0;
  font-size: 48px;
  font-weight: 800;
  line-height: 50px;
}

.banner__info-description {
  color: #000;
  margin-top: 20px;
  padding-top: 0;
  padding-bottom: 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}

.banner__info-content {
  grid-column-gap: 20px;
  grid-row-gap: 0px;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 10px;
  padding-top: 0;
  display: flex;
}

.banner__info-block {
  width: 35%;
}

.button__subscribe {
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
}

.section__student-title {
  color: #009db7;
  margin-bottom: 15px;
  font-size: 32px;
  font-weight: 800;
  line-height: 30px;
}

.banner__info-title strong{
  color: #009db7 !important
}

.section__student-title.form__title {
  border-right: 0 solid #e1e1e1;
  line-height: 44px;
}

.text-block-13 {
  font-weight: 400;
  line-height: 24px;
}

.image-21 {
  position: absolute;
  top: 0%;
  bottom: auto;
  left: auto;
  right: 0%;
}

.teacher__content {
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 20px;
  padding-left: 25px;
  padding-right: 25px;
  display: flex;
}

.section__testimonial {
  white-space: normal;
  background-color: #f4f1e1;
  padding-top: 100px;
  padding-bottom: 100px;
  position: relative;
}

.testimonial__box {
  display: flex;
}

.testimonail__content {
  width: 54%;
  margin-left: 40px;
  position: relative;
}

.testomial__description {
  z-index: 2;
  color: #000;
  -webkit-text-fill-color: inherit;
  background-color: #f4f1e1;
  background-clip: border-box;
  margin-left: auto;
  margin-right: auto;
  font-size: 14px;
  line-height: 20px;
  display: inline-block;
  position: relative;
  overflow: visible;
}

.testomial__title {
  color: #009db7;
  margin-top: 20px;
  font-size: 24px;
  font-weight: 800;
  line-height: 36px;
}

.testomial__position {
  color: #009db7;
  font-size: 14px;
  font-weight: 800;
  line-height: 20px;
}

.testomial__link {
  direction: ltr;
  color: #fff;
  letter-spacing: .48px;
  background-color: #009db7;
  border-radius: 24px;
  margin-top: 20px;
  padding: 10px 30px;
  font-size: 12px;
  line-height: 14px;
  text-decoration: none;
  display: inline-block;
}

.testomial__link:hover {
  color: #fff;
}

.image-22 {
  width: 208px;
  height: 208px;
}

.image-23 {
  z-index: 1;
  position: absolute;
  top: -15%;
  bottom: auto;
  left: -5%;
  right: auto;
}

.image-24 {
  z-index: 1;
  position: absolute;
  top: 55px;
  bottom: 0%;
  left: auto;
  right: -5%;
}

.image-25 {
  position: absolute;
  top: auto;
  bottom: 0%;
  left: auto;
  right: -2%;
}

.section__form {
  background-color: #f4f1e1;
  padding-top: 60px;
  padding-bottom: 60px;
  display: none;
}

.form__columns {
  display: block;
}

.form__column-left {
  border-right: 1px solid #e1e1e1;
  border-radius: 0;
  padding-left: 0;
  padding-right: 40px;
}

.form {
  -webkit-backdrop-filter: blur(9px);
  backdrop-filter: blur(9px);
  display: block;
}

.checkbox {
  width: auto;
  margin-top: 0;
}

.link {
  color: #009db7;
  -webkit-text-stroke-color: #009db7;
  display: inline-block;
}

.form__column-right {
  padding-left: 40px;
}

.form__banner {
  width: 368px;
  opacity: .9;
  background-color: #fff;
  border-radius: 12px;
  margin-right: 0;
  padding: 26px 35px;
  position: absolute;
  top: -4%;
  bottom: auto;
  left: auto;
  right: 10%;
}

.form_banner-title {
  color: #009db7;
  padding-bottom: 20px;
  padding-right: 0;
  font-size: 20px;
  font-weight: 800;
  line-height: 24px;
}

.header_-fixed-menu {
  z-index: 2;
  height: 60px;
  background-color: #fff;
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
  display: none;
  position: fixed;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: 0%;
}

.header__fixed-content {
  grid-column-gap: 30px;
  justify-content: center;
  align-items: center;
  display: flex;
  position: relative;
}

.header__fixed-link {
  color: #000;
  text-transform: none;
  align-self: auto;
  font-size: 16px;
  font-weight: 800;
  line-height: 14px;
  text-decoration: none;
}

.section__certification {
  background-color: #f4f1e1;
  justify-content: center;
  padding-top: 100px;
  padding-bottom: 100px;
  display: flex;
  position: relative;
}

.certification__items {
  width: 79%;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-auto-columns: 1fr;
  justify-content: space-between;
  align-items: center;
  justify-items: center;
  display: grid;
}

.certification__item {
  text-align: center;
  flex-direction: column;
  align-items: center;
  display: flex;
}

.certification__icon-box {
  width: 133px;
  height: 133px;
  background-color: #f5f4ee;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  display: flex;
}

.certification__text {
  padding-top: 20px;
  line-height: 24px;
}

.image-30 {
  width: auto;
  height: auto;
}

.image-32 {
  position: absolute;
  top: -29%;
  bottom: auto;
  left: 0%;
  right: auto;
}

.bold-text-2 {
  display: inline;
}

.link-2 {
  color: #009688;
  display: inline;
}

.abs_bubble.bubble_module {
  position: absolute;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: auto;
}

.subscribe__box-white-title {
  color: #009db7;
  white-space: normal;
  font-weight: 800;
}

.subscribe__right-column {
  flex: 1 1;
  padding-left: 10px;
}

.subscribe__box {
  width: 100%;
  height: 250px;
  clear: none;
  grid-column-gap: 0px;
  grid-row-gap: 7px;
  object-fit: fill;
  background-color: #fff;
  border-radius: 10px;
  flex-direction: column;
  flex: 0 1 auto;
  order: 0;
  justify-content: flex-start;
  align-self: center;
  align-items: flex-start;
  margin-left: auto;
  margin-right: auto;
  padding: 40px 25px 25px;
  display: flex;
  position: relative;
  left: 0;
  right: 0;
}

.subscribe__boxes {
  grid-column-gap: 20px;
  grid-row-gap: 16px;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-columns: 1fr;
  justify-content: space-between;
  margin-top: 20px;
  display: grid;
}

.link-3 {
  width: 205px;
  height: 62px;
  color: #009db7;
  -webkit-text-stroke-color: #009db7;
  mix-blend-mode: normal;
  object-fit: fill;
  background-color: #fff;
  border-radius: 41px;
  justify-content: center;
  align-items: center;
  margin-top: 35px;
  margin-bottom: 35px;
  padding-top: 0;
  padding-bottom: 0;
  font-size: 18px;
  font-weight: 800;
  line-height: 28px;
  text-decoration: none;
  display: flex;
  position: static;
  overflow: visible;
}

.link-3:hover {
  color: #009db7;
}

.subscribe__box-title {
  color: #000;
  letter-spacing: 2px;
  text-transform: uppercase;
  white-space: normal;
  margin-top: 0;
  padding-top: 0;
  font-size: 10px;
  font-weight: 700;
  line-height: 32px;
}

.subscribe__subtitle {
  color: #fff;
  text-align: center;
  background-color: rgba(0, 0, 0, 0);
  font-weight: 400;
  line-height: 24px;
}

.subscribe__subtitle.subscribe__normal-text {
  text-align: left;
  font-size: 24px;
  font-weight: 800;
  line-height: 36px;
}

.subscribe__box-white {
  width: 100%;
  background-color: #fff;
  border-radius: 12px;
  margin-top: 20px;
  padding: 30px 40px;
}

.section__subscribe {
  -webkit-text-fill-color: inherit;
  background-color: #009db7;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: 0 0;
  background-size: auto;
  background-clip: border-box;
  padding-top: 40px;
  padding-bottom: 40px;
  position: relative;
}

.subscribe__box-white-text {
  color: #000;
}

.subscribe__container {
  max-width: 100%;
  flex-direction: column;
  display: flex;
}

.subscribe__box-subtitle {
  color: #000;
  font-size: 14px;
  line-height: 21px;
}

.subscribe__left-column {
  flex: 1 1;
}

.subscribe__investment-title {
  color: #fff;
  margin-bottom: 25px;
  font-size: 32px;
  font-weight: 800;
}

.subscribe__investment-box {
  margin-top: 20px;
}

.subscribe__columns {
  width: 100%;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  object-fit: fill;
  border-bottom: 0 solid #000;
  justify-content: space-between;
  align-self: auto;
  margin-top: 40px;
  margin-left: 0;
  margin-right: 0;
  display: flex;
}

.subscribe__box-image {
  width: auto;
  height: auto;
}

.subscribe__box-image.image-pre-requisites {
  margin-bottom: 5px;
  padding-top: 5px;
}

.bold-text-3 {
  font-size: 24px;
  font-weight: 800;
  line-height: 22px;
}

.subscribe__uppertext {
  color: #fff;
  letter-spacing: 2px;
  font-size: 10px;
  font-weight: 800;
  line-height: 32px;
}

.subscribe__payments {
  color: #fff;
  font-weight: 300;
  line-height: 24px;
}

.image-33 {
  flex: 0 1 auto;
  align-self: auto;
  margin-left: 0;
  margin-right: auto;
}

.text-span {
  color: #009db7;
}

.default_title {
  color: #009db7;
  font-size: 32px;
  font-weight: 800;
  line-height: 44px;
  margin-bottom: 10px;
}

.courses_filter-container {
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
  padding-left: 100px;
  padding-right: 100px;
  display: flex;
}

.courses_form-filter {
  width: 100%;
  position: relative;
}
.search-icon{
  position: absolute;
  top: 10px;
}

.form-filter-input {
  color: #000;
  background-color: rgba(0, 0, 0, 0);
  border: 0 solid #000;
  border-bottom: 1px solid #009db7;
  font-size: 14px;
  line-height: 20px;
  padding-left: 30px;
}

.course-item-columns {
  justify-content: space-between;
  align-self: stretch;
  margin-left: 0;
  margin-right: 0;
  display: flex;
}

.item-left-column {
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  display: flex;
}

.item-right-column {
  flex-flow: column;
  flex: 0 1 auto;
  align-items: flex-start;
  display: flex;
}

.course-title {
  padding-right: 0;
  font-size: 27px;
  font-weight: 800;
  line-height: 30px;
  margin-bottom: 40px;
}
.course-text{
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #edecec;
  text-align: center;
  padding-left: 80px;
}

.course-buttons-box {
  justify-content: space-between;
  display: flex;
}

.course-default-button {
  color: #1a1b1f;
  text-transform: uppercase;
  border: 1px solid #000;
  border-radius: 24px;
  padding: 10px 20px;
  font-size: 12px;
  font-weight: 800;
  text-decoration: none;
  display: inline-block;
  transition: 0.3s all;
  cursor: pointer;
}

.course-default-button.alt-button {
  color: #009db7;
  border-color: #009db7;
  line-height: 14px;
}

.course-default-button.alt-button:hover {
  background: #009db7;
  color: #fff;
}

.course-default-button.default-button {
  color: #fff;
  background-color: #009db7;
  border-color: #009db7;
  line-height: 14px;
}

.course-default-button.default-button:hover {
  color: #009db7;
  background-color: #fff;
}

.course-default-button.secondary-button {
  color: #fff;
  background-color: #b1965f;
  border-color: #b1965f;
  line-height: 14px;
}

.course-default-button.secondary-button :hover {
  color: #b1965f;
  background-color: #fff;
}

.course-date-box {
  grid-column-gap: 5px;
  display: flex;
}

.course-date {
  font-weight: 400;
  line-height: 24px;
}

.course-investment-box {
  border-top: 1px solid #edecec;
  margin-top: 15px;
  padding-top: 15px;
}

.course__old-price {
  color: #000;
  line-height: 24px;
  text-decoration: line-through;
  white-space: pre-line;
}

.course_price {
  color: #009db7;
  font-size: 48px;
  font-weight: 800;
  line-height: 50px;
  white-space: pre-line;
}

.course_discount {
  color: #009db7;
  font-size: 14px;
  line-height: 20px;
}

.superscript {
  font-size: 27px;
}

.image-34 {
  width: 17px;
  height: 20px;
}

.course_info-box {
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
  position: relative;
}

.course_load-more-box {
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
}

.course_category-section {
  margin-bottom: 50px;
}

.form__block {
  padding-top: 40px;
}

.modal__header {
  width: 100%;
  background-color: #f5f4ee;
  border-radius: 12px;
  padding-left: 40px;
  padding-right: 40px;
  position: relative;
}

.modal__content {
  width: 50%;
  height: auto;
  opacity: 1;
  color: #000;
  -webkit-text-fill-color: inherit;
  mix-blend-mode: normal;
  object-fit: fill;
  background-color: #f5f4ee;
  background-clip: border-box;
  border-radius: 12px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-top: 0%;
  margin-left: auto;
  margin-right: auto;
  padding-left: 0;
  padding-right: 0;
  display: flex;
  position: relative;
  overflow: visible;
}

.form__group-2 {
  margin-bottom: 0;
  padding-top: 5px;
  padding-bottom: 10px;
  position: relative;
}

.form__group-2.form__group-button {
  justify-content: center;
  align-items: center;
  padding-top: 30px;
  padding-bottom: 30px;
  display: flex;
}

.modal__uppertitle {
  color: #000;
  letter-spacing: 2px;
  margin-top: 10px;
  margin-bottom: 0;
  font-size: 10px;
  font-weight: 800;
  line-height: 32px;
}

.modal__form {
  width: 100%;
  -webkit-text-fill-color: inherit;
  background-color: #fff;
  background-clip: border-box;
  border-radius: 12px;
  padding-left: 40px;
  padding-right: 40px;
}

.form__select-file {
  background-color: #f4f1e1;
  border-radius: 24px;
  margin-top: 10px;
  padding: 10px 20px;
  font-size: 10px;
  font-weight: 800;
  line-height: 14px;
  display: block;
  position: absolute;
  top: 0%;
  bottom: auto;
  left: auto;
  right: 0%;
}

.form__label-2 {
  letter-spacing: 0;
  text-transform: none;
  margin-bottom: 5px;
  font-weight: 800;
  line-height: 14px;
}

.checkbox-label-2 {
  letter-spacing: 0;
  text-transform: none;
  line-height: 16px;
  text-decoration: none;
}

.form__modal {
  flex-direction: column;
  display: block;
}

.section__modal {
  z-index: 10;
  width: 100%;
  opacity: 1;
  color: #1a1b1f;
  background-color: rgba(0, 0, 0, .88);
  flex-direction: row;
  display: none;
  position: fixed;
  top: 0%;
  bottom: 0%;
  left: 0%;
  right: 0%;
  overflow: hidden;
}

.modal__title {
  color: #006a99;
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 32px;
  font-weight: 300;
  line-height: 39px;
}

.form__input-2 {
  border: 0 solid #000;
  border-bottom-width: 1px;
  font-size: 12px;
}

.modal__close {
  z-index: 2;
  width: 40px;
  height: 40px;
  background-color: #fff;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-right: 20px;
  padding-top: 0;
  display: flex;
  position: absolute;
  top: 0%;
  bottom: auto;
  left: auto;
  right: 0%;
  cursor: pointer;
}

.modal__container {
  width: 100%;
  height: 100%;
  opacity: 1;
  white-space: normal;
  -webkit-text-fill-color: inherit;
  mix-blend-mode: normal;
  background-color: #0000;
  background-clip: border-box;
  padding-top: 60px;
  padding-bottom: 60px;
  display: block;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.submit-button-2 {
  width: 112px;
  height: 38px;
  letter-spacing: 1px;
  background-color: #006a99;
  border-radius: 24px;
  padding-left: 20px;
  padding-right: 20px;
  font-size: 11px;
  font-weight: 800;
  line-height: 14px;
  display: block;
}

.modal_container {
  width: 100%;
  padding: 40px 49px;
  height: 600px;
  overflow-y: scroll;
}

.modal_course-title {
  color: #000;
  margin-bottom: 20px;
  font-size: 27px;
  font-weight: 800;
  line-height: 34px;
}

.modal_course-text {
  line-height: 24px;
  white-space: pre-line
}

.modal__conteudo *{
  line-height: 24px;
  white-space: pre-line;
  margin-bottom: 0px;
}

.modal__conteudo ul{
  line-height: 24px;
  margin-top: 10px;
}

.modal__conteudo li{
  line-height: 24px;
  margin-bottom: 5px;
}

.modal_course-block {
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-columns: 1fr;
  margin-top: 20px;
  margin-bottom: 20px;
  display: block;
}

.modal_course-block.course-block-items {
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-columns: 1fr;
  margin-top: 40px;
  margin-bottom: 40px;
  display: grid;
}

.modal_course-subtitle {
  color: #009db7;
  margin-bottom: 5px;
  font-size: 20px;
  font-weight: 800;
  line-height: 24px;
}

.modal_course-block-item {
  flex-direction: column;
  display: block;
}

.course-block-icon {
  margin-bottom: 5px;
}

.image-35 {
  background-color: #fff;
}

.section__modal {
  display: block;
}

@media screen and (min-width: 1440px) {
  .section__courses {
    padding-top: 100px;
    padding-bottom: 100px;
  }

  .center.banner__info-container.pos-relative {
    position: relative;
  }

  .courses__container {
    padding-top: 0;
    padding-bottom: 0;
  }

  .section__teacher {
    justify-content: center;
    display: flex;
  }

  .selo__mec {
    height: auto;
  }

  .section__cookies {
    opacity: .89;
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    background-color: #fff;
    padding-top: 20px;
    padding-bottom: 20px;
    position: fixed;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .cookies__text {
    z-index: 2;
    color: #000;
    object-fit: fill;
    font-size: 14px;
    line-height: 24px;
    position: relative;
  }

  .cookies__container {
    z-index: auto;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    display: flex;
    position: relative;
  }

  .cookies__button {
    color: #fff;
    letter-spacing: .48px;
    background-color: #009db7;
    border-radius: 24px;
    padding: 10px 20px;
    font-size: 12px;
    font-weight: 700;
    line-height: 14px;
    text-decoration: none;
  }

  .cookies__button.button__subscribe-link.subscribe__teacher {
    left: auto;
    right: auto;
  }

  .form__grid {
    grid-column-gap: 36px;
    grid-row-gap: 16px;
  }

  .banner__desktop-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    min-height: 600px;
  }

  .button__subscribe {
    font-size: 15px;
  }

  .banner__info{
    height: 65%;
  }

  .form__banner {
    right: 0%;
  }

  .section__certification {
    justify-content: center;
    display: flex;
  }


}

@media screen and (max-width: 991px) {
  .section__courses {
    padding-top: 10px;
    padding-bottom: 60px;
  }

  .section__courses.cc-cta {
    padding-left: 0;
    padding-right: 0;
  }

  .center {
    padding-left: 40px;
    padding-right: 40px;
  }

  .center.center__inner {
    margin-left: auto;
    margin-right: auto;
  }

  .button {
    justify-content: center;
  }

  .button.cc-contact-us {
    display: none;
  }

  .heading-jumbo {
    font-size: 56px;
    line-height: 70px;
  }

  .logo-link.w--current {
    flex: 1 1;
  }

  .menu-icon {
    display: block;
  }

  .menu {
    margin-left: 30px;
    position: static;
  }

  .navigation-wrap {
    background-color: #fff;
  }

  .navigation {
    padding: 25px 30px;
  }

  .navigation-item {
    text-align: center;
    padding: 15px 30px;
    transition: background-color .4s, opacity .4s, color .4s;
  }

  .navigation-item:hover {
    background-color: #f7f8f9;
  }

  .navigation-item:active {
    background-color: #eef0f3;
  }

  .menu-button {
    padding: 0;
  }

  .menu-button.w--open {
    background-color: rgba(0, 0, 0, 0);
  }

  .navigation-items {
    background-color: #fff;
  }

  .cta-text {
    width: auto;
  }

  .cta-wrap {
    width: auto;
    padding: 80px 50px 90px;
  }

  .blog-detail-header-wrap {
    width: 70%;
  }

  .detail-header-image {
    height: 460px;
  }

  .title__center {
    overflow: visible;
  }

  .courses__container {
    padding-top: 0;
    padding-bottom: 0;
  }

  .section__teacher {
    justify-content: center;
    align-items: stretch;
  }

  .teacher__container {
    display: block;
  }

  .teacher__grid {
    z-index: 2;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    align-content: stretch;
    justify-content: center;
    justify-items: center;
    position: relative;
  }

  .selo__mec {
    width: auto;
    height: auto;
  }

  .footer_columns {
    grid-row-gap: 25px;
    flex-direction: column-reverse;
    display: flex;
  }

  .footer__column-logo {
    justify-content: center;
    align-self: center;
    display: flex;
  }

  .footer_column-content {
    align-self: center;
  }

  .footer__social-media {
    width: 100%;
  }

  .section__banner {
    height: 770px;
  }

  .about__image {
    width: 100%;
  }

  .about__columns {
    flex-direction: column;
  }

  .about__column-left {
    align-self: auto;
    padding-bottom: 40px;
  }

  .cookies__button.button__subscribe-link.subscribe__teacher {
    top: -24px;
    left: auto;
  }

  .form__group {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .form__grid {
    grid-template-rows: auto;
    grid-template-columns: 1fr;
  }

  .banner__menu_container {
    display: none;
  }

  .banner__desktop-image {
    width: auto;
    height: 770px;
    object-fit: cover;
  }

  .banner__info {
    margin-top: 0;
  }

  .banner__info-block {
    width: 56%;
  }

  .image-24 {
    top: 65px;
    right: -9%;
  }

  .image-25.abs_bubble,
  .form__banner,
  .header_-fixed-menu {
    display: none;
  }

  .certification__items {
    grid-template-columns: 1fr 1fr;
  }

  .image-32 {
    display: none;
  }

  .subscribe__right-column {
    padding-bottom: 40px;
    padding-left: 0;
  }

  .subscribe__columns {
    flex-direction: column-reverse;
    display: flex;
  }

  .bold-text-4 {
    font-size: 25px;
    line-height: 28px;
  }

  .form__group-2 {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .form__select-file {
    position: static;
  }

  .modal__title {
    font-size: 25px;
    line-height: 26px;
  }

  .form__grid-2 {
    grid-template-rows: auto;
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 767px) {
  .section__courses {
    margin-left: 0;
    margin-right: 0;
  }

  .section__courses.cc-cta {
    padding: 15px;
  }

  .center {
    text-align: center;
  }

  .center.banner__info-container {
    text-align: left;
  }

  .paragraph-bigger {
    font-size: 16px;
    line-height: 28px;
  }

  .rich-text {
    width: 90%;
    max-width: 470px;
    text-align: left;
  }

  .heading-jumbo {
    font-size: 50px;
    line-height: 64px;
  }

  .heading-jumbo-small {
    font-size: 30px;
    line-height: 52px;
  }

  .logo-link {
    padding-left: 0;
  }

  .navigation {
    padding: 20px 30px;
  }

  .cta-wrap {
    padding-left: 30px;
    padding-right: 30px;
  }

  .blog-detail-header-wrap {
    width: 90%;
    max-width: 470px;
    text-align: left;
  }

  .utility-page-wrap {
    padding: 15px;
  }

  ._404-wrap {
    padding: 30px;
  }

  .courses__container {
    width: 100%;
    padding-top: 10px;
  }

  .modules__item-title {
    flex: none;
  }

  .modules__subtitle {
    text-align: left;
  }

  .bold-text {
    font-size: 20px;
  }

  .dpo__columns {
    grid-row-gap: 21px;
    flex-direction: column;
    justify-content: flex-start;
  }

  .dpo__left-column {
    text-align: center;
  }

  .dpo__right-column {
    flex: 0 1 auto;
    justify-content: center;
    align-self: center;
    align-items: center;
    display: flex;
  }

  .dpo__title {
    text-align: center;
  }

  .selo__mec {
    width: auto;
    height: auto;
    display: block;
  }

  .section__footer {
    padding-top: 0;
    padding-bottom: 0;
  }

  .footer__social-media {
    grid-row-gap: 25px;
    flex-direction: column;
    align-items: center;
    display: flex;
  }

  .social__whatsapp {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    display: flex;
  }

  .social__faleconosco {
    grid-row-gap: 0px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .social__follow {
    flex-direction: column;
    align-items: center;
    display: flex;
  }

  .section__about {
    padding-bottom: 10px;
  }

  .default__uupertitle,
  .cookies__text {
    text-align: left;
  }

  .banner__info-block {
    width: 90%;
  }

  .text-block-13 {
    text-align: left;
  }

  .section__certification {
    padding-top: 40px;
  }

  .subscribe__box-white-title {
    text-align: left;
  }

  .link-3 {
    flex-direction: row;
    justify-content: center;
    align-self: center;
    align-items: center;
    display: flex;
  }

  .subscribe__subtitle.subscribe__normal-text {
    text-align: left;
    font-size: 15px;
  }

  .subscribe__box-white-text {
    text-align: left;
  }

  .subscribe__left-column {
    flex-direction: column;
    align-self: auto;
    display: flex;
  }

  .subscribe__columns {
    align-self: auto;
  }

  .bold-text-4 {
    font-size: 21px;
  }

  .modal__title {
    font-size: 19px;
  }
  .course-text{
    padding-left: 0px;
  }
  
}

@media screen and (max-width: 479px) {
  h1 {
    font-size: 36px;
    line-height: 52px;
  }

  .section__courses {
    padding-top: 40px;
  }

  .center {
    margin-left: auto;
    margin-right: auto;
    padding-left: 20px;
    padding-right: 20px;
  }

  .rich-text {
    width: 100%;
    max-width: none;
  }

  .heading-jumbo {
    font-size: 36px;
    line-height: 48px;
  }

  .menu {
    margin-left: 15px;
  }

  .navigation {
    padding-left: 20px;
    padding-right: 20px;
  }

  .menu-button,
  .menu-button.w--open {
    flex: none;
  }

  .cta-wrap {
    padding-left: 15px;
    padding-right: 15px;
  }

  .blog-detail-header-wrap {
    width: 100%;
    max-width: none;
  }

  .section-heading {
    font-size: 24px;
    line-height: 24px;
  }

  .title__center {
    margin-top: 40px;
    padding-top: 0;
    font-size: 26px;
    line-height: 28px;
  }

  .courses__container {
    width: 100%;
    padding-top: 0;
    padding-bottom: 0;
  }

  .course-item-box {
    flex-direction: column;
    align-items: center;
    padding-left: 20px;
    padding-right: 20px;
  }

  .modules__item-title {
    font-size: 17px;
  }

  .modules__subtitle {
    text-align: center;
    font-size: 16px;
    line-height: 17px;
  }

  .bold-text {
    align-items: center;
    font-size: 18px;
  }

  .modules__icon {
    display: none;
  }

  .modules__item-header {
    flex-direction: column;
  }

  .section__teacher {
    padding-bottom: 60px;
  }

  .subscribe__module-title {
    text-align: center;
    font-size: 34px;
    line-height: 40px;
  }

  .teacher__grid {
    grid-template-columns: 1fr;
  }

  .dpo__description {
    text-align: center;
    line-height: 17px;
  }

  .selo__mec {
    height: auto;
  }

  .header__container {
    justify-content: center;
  }

  .header__link {
    display: block;
  }

  .section__banner {
    width: 100%;
    height: 500px;
  }

  .section__about {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .sidebar {
    display: none;
  }

  .about__column-left {
    padding-bottom: 10px;
  }

  .default__uupertitle {
    font-size: 15px;
    line-height: 24px;
  }

  .default__uupertitle.center-text {
    text-align: center;
  }

  .section__cookies {
    display: none;
  }

  .cookies__text {
    text-align: center;
  }

  .cookies__container {
    grid-row-gap: 19px;
    text-align: center;
    flex-direction: column;
  }

  .cookies__button.button__subscribe-link {
    width: 334px;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    text-align: left;
    object-fit: fill;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    align-self: auto;
    display: flex;
  }

  .cookies__button.button__subscribe-link.subscribe__teacher {
    width: 88%;
    display: none;
  }

  .form__group {
    text-align: left;
    padding-bottom: 0;
  }

  .form__group.form__group-button {
    text-align: left;
    justify-content: center;
    padding-top: 10px;
  }

  .form__label {
    margin-bottom: 0;
    padding-bottom: 10px;
  }

  .submit-button.form__submit {
    width: 100%;
  }

  .banner__menu {
    height: 150px;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    flex-direction: column-reverse;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    align-items: flex-start;
    margin-top: 10px;
    padding-left: 20px;
    display: flex;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: auto;
  }

  .banner__desktop-image {
    filter: brightness();
    -webkit-text-fill-color: inherit;
    background-color: rgba(0, 0, 0, 0);
    background-clip: border-box;
  }

  .banner__info {
    z-index: 5;
    top: 21%;
  }

  .banner__info-uppertitle.banner-info-dates,
  .banner__info-uppertitle.text-center {
    width: 100%;
  }

  .banner__info-title {
    font-size: 31px;
    line-height: 33px;
  }

  .banner__info-description {
    font-size: 15px;
    line-height: 23px;
  }

  .banner__info-content {
    grid-row-gap: 10px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  .banner__info-block {
    width: 100%;
  }

  .button__subscribe {
    font-size: 11px;
    line-height: 21px;
  }

  .button__subscribe-icon {
    display: none;
  }

  .section__student-title.form__title {
    text-align: center;
  }

  .text-block-13 {
    text-align: left;
  }

  .image-21.abs_bubble {
    display: none;
  }

  .section__testimonial {
    padding-top: 60px;
    padding-bottom: 60px;
  }

  .testimonial__box {
    flex-direction: column;
    align-items: center;
  }

  .testimonail__content {
    width: 100%;
    margin-top: 40px;
    margin-left: 0;
  }

  .image-23 {
    display: none;
    top: -13%;
    left: -9%;
  }

  .image-24 {
    display: none;
    top: 29%;
  }

  .section__form {
    padding-top: 40px;
    padding-bottom: 0;
  }

  .form__column-left {
    padding-right: 0;
  }

  .form__column-right {
    padding-left: 0;
  }

  .section__certification {
    padding-top: 40px;
    padding-bottom: 60px;
  }

  .certification__items {
    grid-template-columns: 1fr;
  }

  .subscribe__box {
    height: auto;
  }

  .subscribe__boxes {
    height: auto;
    grid-template-columns: 1fr;
  }

  .link-3 {
    font-size: 16px;
  }

  .subscribe__subtitle.subscribe__normal-text {
    display: none;
  }

  .subscribe__box-white {
    flex-direction: column;
    padding-left: 40px;
    padding-right: 40px;
    display: flex;
  }

  .section__subscribe {
    padding-top: 0;
  }

  .subscribe__container {
    flex-direction: column-reverse;
    align-items: stretch;
  }

  .subscribe__box-subtitle {
    text-align: left;
  }

  .subscribe__investment-title {
    font-size: 26px;
  }

  .subscribe__columns {
    flex-direction: column-reverse;
  }

  .logo-ens,
  .logo-unisincor {
    width: 200px;
  }

  .courses_filter-container {
    padding-left: 0;
    padding-right: 0;
  }

  .form-filter {
    width: 100%;
  }

  .course-item-columns {
    grid-column-gap: 0px;
    grid-row-gap: 20px;
    flex-direction: column;
  }

  .item-right-column {
    flex-direction: column;
    align-items: center;
  }

  .course-title {
    text-align: left;
  }

  .course-buttons-box {
    grid-row-gap: 10px;
    flex-direction: column;
  }

  .course_info-box {
    width: 100%;
  }

  .modal__content {
    width: 90%;
  }

  .bold-text-4 {
    font-size: 18px;
    line-height: 17px;
  }

  .modal__uppertitle {
    font-size: 9px;
    line-height: 21px;
  }

  .modal__form {
    padding-left: 20px;
    padding-right: 20px;
  }

  .form__label-2 {
    margin-bottom: 0;
  }

  .section__modal {
    display: block;
  }

  .modal__title {
    font-size: 16px;
    line-height: 22px;
  }

  .modal__close {
    width: 30px;
    height: 30px;
    line-height: 28px;
  }

  .modal_container {
    padding-left: 20px;
    padding-right: 20px;
  }

  .modal_course-block.course-block-items {
    grid-template-columns: 1fr;
  }

  .modal_course-block-item {
    align-items: center;
    display: flex;
  }
}


.fade-effect {
  height: 40px;
  background: transparent linear-gradient(180deg, #F4F1E100 0%, #F4F1E1CF 65%, #F4F1E1 100%) 0% 0% no-repeat padding-box;
  width: 100%;
  position: absolute;
  bottom: 0px;

}

.footer_banner{
  width: 100%
}

.footer_banner-image{
  width: 100%
}`, "",{"version":3,"sources":["webpack://./src/general/css/main.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,SAAO;EACP,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAMA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uFAAuF;EACvF,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;EAC7B,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,sCAAsC;EACtC,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,gCAAgC;EAChC,yDAAqE;EACrE,wBAAwB;EACxB,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,SAAS;EACT,UAAU;EACV,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,SAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,MAAM;AACR;;AAEA;EACE,gBAAgB;EAChB,cAAY;EACZ,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,0BAA0B;EAC1B,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,SAAS;EACT,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,gCAAgC;EAChC,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kCAAkC;EAClC,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,kCAAkC;EAClC,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;AACF;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,yBAAyB;EACzB,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,SAAS;EACT,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,OAAO;EACP,YAAY;EACZ,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,sCAAsC;EACtC,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,cAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,kCAAkC;EAClC,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,yDAAqE;EACrE,wBAAwB;EACxB,qBAAqB;EACrB,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAY;EACZ,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,OAAO;EACP,UAAU;EACV,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,UAAU;EACV,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kCAAkC;IAClC,0BAA0B;IAC1B,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,aAAa;EACf;;;AAGF;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,wDAAwD;EAC1D;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;IAC9B,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;;AAEF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,8BAA8B;IAC9B,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,gCAAgC;IAChC,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,QAAQ;EACV;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,SAAS;EACX;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,8BAA8B;IAC9B,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;AACF;;;AAGA;EACE,YAAY;EACZ,sHAAsH;EACtH,WAAW;EACX,kBAAkB;EAClB,WAAW;;AAEb;;AAEA;EACE;AACF;;AAEA;EACE;AACF","sourcesContent":["body {\n  color: #1a1b1f;\n  font-family: Outfit, sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 28px;\n}\n\nh1 {\n  margin-top: 20px;\n  margin-bottom: 15px;\n  font-size: 44px;\n  font-weight: 400;\n  line-height: 62px;\n}\n\nh2 {\n  margin-top: 10px;\n  margin-bottom: 10px;\n  font-size: 36px;\n  font-weight: 400;\n  line-height: 50px;\n}\n\nh3 {\n  margin-top: 10px;\n  margin-bottom: 10px;\n  font-size: 30px;\n  font-weight: 400;\n  line-height: 46px;\n}\n\nh4 {\n  margin-top: 10px;\n  margin-bottom: 10px;\n  font-size: 24px;\n  font-weight: 400;\n  line-height: 38px;\n}\n\nh5 {\n  margin-top: 10px;\n  margin-bottom: 10px;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 34px;\n}\n\nh6 {\n  margin-top: 10px;\n  margin-bottom: 10px;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 28px;\n}\n\np {\n  margin-bottom: 10px;\n}\n\na {\n  color: #1a1b1f;\n  text-decoration: underline;\n  transition: opacity .2s;\n  display: block;\n}\n\na:hover {\n  color: #32343a;\n}\n\na:active {\n  color: #43464d;\n}\n\nul {\n  margin-top: 20px;\n  margin-bottom: 10px;\n  padding-left: 40px;\n  list-style-type: disc;\n}\n\nli {\n  margin-bottom: 10px;\n}\n\nimg {\n  display: block;\n}\n\nlabel {\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 20px;\n}\n\nblockquote {\n  border-left: 5px solid #e2e2e2;\n  margin-top: 25px;\n  margin-bottom: 25px;\n  padding: 15px 30px;\n  font-size: 20px;\n  line-height: 34px;\n}\n\nfigcaption {\n  opacity: 1;\n  text-align: center;\n  margin-top: 5px;\n  font-size: 14px;\n  line-height: 26px;\n}\n\n.section__courses {\n  background-color: #f5f4ee;\n  margin-left: 0;\n  margin-right: 0;\n  padding-top: 40px;\n  padding-bottom: 40px;\n  position: relative;\n}\n\n.section__courses.cc-cta {\n  background-color: #f4f4f4;\n  padding-left: 80px;\n  padding-right: 80px;\n}\n\n.center {\n  width: 100%;\n  max-width: 1224px;\n  margin-top: 0;\n  margin-left: auto;\n  margin-right: auto;\n  padding-bottom: 0;\n  position: static;\n}\n\n.center.center__inner {\n  max-width: 900px;\n}\n\n.center.center__inner.justify-center {\n  justify-content: center;\n  display: flex;\n}\n\n.center.pos-relative {\n  -webkit-text-fill-color: inherit;\n  background-clip: border-box;\n  position: relative;\n}\n\n.center.banner__info-container {\n  width: 100%;\n  display: block;\n  position: static;\n}\n\n.center.center_form {\n  max-width: 1100px;\n}\n\n.center.justify-center {\n  flex-direction: column;\n  align-items: center;\n  display: flex;\n}\n\n.paragraph-tiny {\n  font-size: 12px;\n  line-height: 20px;\n}\n\n.paragraph-bigger {\n  opacity: 1;\n  margin-bottom: 10px;\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 34px;\n}\n\n.paragraph-bigger.cc-bigger-light {\n  opacity: .6;\n}\n\n.button {\n  color: #fff;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  background-color: #1a1b1f;\n  border-radius: 0;\n  padding: 12px 25px;\n  font-size: 12px;\n  line-height: 20px;\n  text-decoration: none;\n  transition: background-color .4s, opacity .4s, color .4s;\n}\n\n.button:hover {\n  color: #fff;\n  background-color: #32343a;\n}\n\n.button:active {\n  background-color: #43464d;\n}\n\n.button.cc-jumbo-button {\n  padding: 16px 35px;\n  font-size: 14px;\n  line-height: 26px;\n}\n\n.button.cc-contact-us {\n  z-index: 5;\n  position: relative;\n}\n\n.button.cc-white-button {\n  color: #202020;\n  background-color: #fff;\n  padding: 16px 35px;\n  font-size: 14px;\n  line-height: 26px;\n}\n\n.button.cc-white-button:hover {\n  background-color: rgba(255, 255, 255, .8);\n}\n\n.button.cc-white-button:active {\n  background-color: rgba(255, 255, 255, .9);\n}\n\n.label {\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.label.cc-blog-date {\n  opacity: .6;\n  margin-top: 20px;\n}\n\n.rich-text {\n  width: 70%;\n  margin-bottom: 100px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.rich-text p {\n  opacity: .6;\n  margin-top: 15px;\n  margin-bottom: 25px;\n}\n\n.rich-text figcaption {\n  opacity: .6;\n}\n\n.rich-text figure {\n  margin-top: 25px;\n  padding-bottom: 20px;\n}\n\n.heading-jumbo {\n  text-transform: none;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  font-size: 64px;\n  line-height: 80px;\n}\n\n.heading-jumbo-small {\n  text-transform: none;\n  margin-top: 10px;\n  margin-bottom: 15px;\n  font-size: 36px;\n  font-weight: 400;\n  line-height: 50px;\n}\n\n.logo-link {\n  z-index: 1;\n}\n\n.logo-link:hover {\n  opacity: .8;\n}\n\n.logo-link:active {\n  opacity: .7;\n}\n\n.menu {\n  z-index: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  position: absolute;\n  top: 0%;\n  bottom: 0%;\n  left: 0%;\n  right: 0%;\n}\n\n.navigation-wrap {\n  flex: 1;\n  justify-content: space-between;\n  align-items: center;\n  display: flex;\n  position: relative;\n}\n\n.navigation {\n  background-color: rgba(0, 0, 0, 0);\n  align-items: center;\n  padding: 30px 50px;\n  display: flex;\n}\n\n.navigation-item {\n  opacity: .6;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  padding-top: 9px;\n  padding-bottom: 9px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.navigation-item:hover {\n  opacity: .9;\n}\n\n.navigation-item:active {\n  opacity: .8;\n}\n\n.navigation-item.w--current {\n  opacity: 1;\n  color: #1a1b1f;\n  font-weight: 600;\n}\n\n.navigation-item.w--current:hover {\n  opacity: .8;\n  color: #32343a;\n}\n\n.navigation-item.w--current:active {\n  opacity: .7;\n  color: #32343a;\n}\n\n.logo-image {\n  display: block;\n}\n\n.navigation-items {\n  flex: none;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n}\n\n.footer-wrap {\n  justify-content: center;\n  align-items: center;\n  padding-top: 70px;\n  padding-bottom: 70px;\n  display: flex;\n}\n\n.webflow-link {\n  opacity: .5;\n  align-items: center;\n  text-decoration: none;\n  transition: opacity .4s;\n  display: flex;\n}\n\n.webflow-link:hover {\n  opacity: 1;\n}\n\n.webflow-link:active {\n  opacity: .8;\n}\n\n.webflow-logo-tiny {\n  margin-top: -2px;\n  margin-right: 8px;\n}\n\n.cta-text {\n  width: 70%;\n  margin-bottom: 35px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.cta-wrap {\n  text-align: center;\n  justify-content: center;\n  padding-top: 110px;\n  padding-bottom: 120px;\n  display: flex;\n}\n\n.status-message {\n  color: #fff;\n  text-align: center;\n  background-color: #202020;\n  padding: 9px 30px;\n  font-size: 14px;\n  line-height: 26px;\n}\n\n.status-message.cc-error-message {\n  background-color: #db4b68;\n}\n\n.text-field {\n  border: 1px solid #e4e4e4;\n  border-radius: 0;\n  margin-bottom: 18px;\n  padding: 21px 20px;\n  font-size: 14px;\n  line-height: 26px;\n  transition: border-color .4s;\n}\n\n.text-field:hover {\n  border-color: #e3e6eb;\n}\n\n.text-field:active,\n.text-field:focus {\n  border-color: #43464d;\n}\n\n.text-field::-ms-input-placeholder {\n  color: rgba(50, 52, 58, .4);\n}\n\n.text-field::placeholder {\n  color: rgba(50, 52, 58, .4);\n}\n\n.blog-detail-header-wrap {\n  width: 70%;\n  margin: 60px auto;\n}\n\n.detail-header-image {\n  width: 100%;\n  height: 620px;\n  background-image: url('https://d3e54v103j8qbb.cloudfront.net/img/background-image.svg');\n  background-position: 0 0;\n  background-size: cover;\n  margin-bottom: 60px;\n  display: block;\n}\n\n.detail-header-image.w--current {\n  margin-bottom: 60px;\n}\n\n.protected-form {\n  flex-direction: column;\n  display: flex;\n}\n\n.protected-wrap {\n  justify-content: center;\n  padding-top: 90px;\n  padding-bottom: 100px;\n  display: flex;\n}\n\n.protected-heading {\n  margin-bottom: 30px;\n}\n\n.utility-page-wrap {\n  width: 100vw;\n  height: 100vh;\n  max-height: 100%;\n  max-width: 100%;\n  color: #fff;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  padding: 30px;\n  display: flex;\n}\n\n._404-wrap {\n  width: 100%;\n  height: 100%;\n  background-color: #1a1b1f;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 30px;\n  display: flex;\n}\n\n._404-content-wrap {\n  margin-bottom: 20px;\n}\n\n.section-heading {\n  color: #009db7;\n  text-align: left;\n  letter-spacing: normal;\n  margin-top: 0;\n  margin-bottom: 20px;\n  font-size: 32px;\n  font-weight: 700;\n  line-height: 44px;\n}\n\n.title__center {\n  color: #009db7;\n  text-align: center;\n  letter-spacing: normal;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  padding-top: 0;\n  font-size: 32px;\n  font-weight: 700;\n  line-height: 44px;\n}\n\n.title__center.title__docente {\n  margin-bottom: 10px;\n}\n\n.courses__container {\n  width: 100%;\n  flex-direction: column;\n  padding-top: 40px;\n  padding-bottom: 60px;\n  display: block;\n}\n\n.course-item-box {\n  width: 100%;\n  height: auto;\n  grid-column-gap: 6px;\n  grid-row-gap: 6px;\n  text-transform: none;\n  white-space: normal;\n  object-fit: fill;\n  background-color: #fff;\n  border-radius: 12px;\n  flex-direction: column;\n  grid-template-rows: auto auto;\n  grid-template-columns: 1fr 1fr;\n  grid-auto-columns: 1fr;\n  justify-content: center;\n  align-items: flex-start;\n  margin-bottom: 0;\n  padding: 30px 60px;\n  line-height: 16px;\n  display: flex;\n  position: relative;\n  overflow: visible;\n}\n\n.course-list {\n  grid-column-gap: 0px;\n  grid-row-gap: 15px;\n  flex-direction: column;\n  justify-content: center;\n  display: flex;\n}\n\n.modules__item-title {\n  margin-top: 0;\n  margin-bottom: 0;\n  margin-right: 5px;\n  font-size: 24px;\n}\n\n.modules__subtitle {\n  color: #009db7;\n  flex: 0 auto;\n  font-size: 20px;\n  font-weight: 800;\n  line-height: 24px;\n}\n\n.bold-text {\n  font-size: 20px;\n  font-weight: 800;\n  line-height: 36px;\n  display: flex;\n}\n\n.modules__icon {\n  z-index: auto;\n  width: 20px;\n  height: 20px;\n  text-align: left;\n  mix-blend-mode: normal;\n  object-fit: fill;\n  position: absolute;\n  top: 32%;\n  bottom: 0%;\n  left: auto;\n  right: 0%;\n}\n\n.modules__item-header {\n  width: 100%;\n  align-items: center;\n  display: flex;\n  position: relative;\n}\n\n.modules__item-content {\n  margin-top: 10px;\n}\n\n.section__teacher {\n  background-color: #f5f4ee;\n  justify-content: center;\n  padding-top: 60px;\n  padding-bottom: 100px;\n  display: flex;\n  position: relative;\n}\n\n.subscribe__module-title {\n  color: #fff;\n  border: 0 solid #fff;\n  margin-bottom: 0;\n  font-family: Outfit, sans-serif;\n  font-size: 48px;\n  font-weight: 800;\n}\n\n.body {\n  font-family: Outfit, sans-serif;\n}\n\n.teacher__container {\n  margin-top: 40px;\n}\n\n.teacher__grid {\n  grid-column-gap: 7px;\n  grid-row-gap: 16px;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  align-content: stretch;\n  justify-content: stretch;\n}\n\n.teacher__item {\n  width: 272px;\n  height: 409px;\n  grid-column-gap: 0px;\n  grid-row-gap: 10px;\n  -webkit-text-fill-color: inherit;\n  background-image: url('../../../public/assets/images/Grupo-6493.png');\n  background-position: 0 0;\n  background-size: auto;\n  background-clip: border-box;\n  border-radius: 12px;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  display: flex;\n}\n\n.teacher__uppertitle {\n  color: #fff;\n  letter-spacing: 0;\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.teacher__name {\n  color: #fff;\n  text-align: left;\n  flex: 0 auto;\n  align-self: auto;\n  font-size: 24px;\n  font-weight: 800;\n  line-height: 36px;\n}\n\n.teacher__description {\n  color: #fff;\n  text-align: left;\n  flex-direction: column;\n  align-self: auto;\n  align-items: center;\n  margin-top: 10px;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  display: block;\n}\n\n.section__dpo {\n  background-color: #f4f1e1;\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n.dpo__columns {\n  align-items: center;\n  display: flex;\n}\n\n.dpo__title {\n  color: #000;\n  text-align: right;\n  font-size: 14px;\n  font-weight: 800;\n  line-height: 20px;\n}\n\n.dpo__description {\n  color: #000;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.selo__mec {\n  width: auto;\n  height: auto;\n  filter: grayscale();\n}\n\n.section__footer {\n  background-color: #009db7;\n  padding-top: 40px;\n  padding-bottom: 40px;\n}\n\n.footer_columns {\n  align-items: center;\n  display: flex;\n}\n\n.footer__column-logo {\n  display: block;\n}\n\n.social__box {\n  grid-column-gap: 8px;\n  justify-content: flex-start;\n  align-items: center;\n  text-decoration: none;\n  display: flex;\n}\n\n.social__box.social__icons {\n  grid-column-gap: 18px;\n}\n\n.footer__title {\n  color: #fff;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  font-size: 10px;\n  font-weight: 800;\n  text-decoration: none;\n}\n\n.footer__text {\n  color: #fff;\n  font-weight: 800;\n  line-height: 24px;\n}\n\n.section__footer-am4 {\n  background-color: #f4f1e1;\n  justify-content: center;\n  align-items: center;\n  padding-top: 17px;\n  padding-bottom: 17px;\n  display: flex;\n}\n\n.header {\n  height: 38px;\n  align-items: center;\n  padding-top: 0;\n  padding-bottom: 0;\n  display: flex;\n}\n\n.header__container {\n  justify-content: flex-start;\n  align-items: center;\n  display: flex;\n  position: relative;\n}\n\n.header__link {\n  color: #009db7;\n  -webkit-text-stroke-color: #009db7;\n  text-transform: uppercase;\n  align-self: auto;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 14px;\n  text-decoration: none;\n}\n\n.section__banner {\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  display: flex;\n  min-height: 500px;\n  position: relative;\n  background: #f4f1e1;\n}\n\n.section__about {\n  background-color: #f4f1e1;\n  padding-top: 100px;\n  padding-bottom: 90px;\n  position: relative;\n}\n\n.sidebar {\n  z-index: auto;\n  flex-direction: column;\n  align-items: flex-end;\n  display: flex;\n  position: fixed;\n  top: auto;\n  bottom: 2%;\n  left: auto;\n  right: 2%;\n}\n\n.link-block {\n  color: #fff;\n  background-color: #006a99;\n  text-decoration: none;\n}\n\n.link-block.subscribe__link {\n  grid-column-gap: 15px;\n  border-radius: 70px;\n  align-items: center;\n  padding: 15px 25px;\n  display: flex;\n}\n\n.whatsapp__link {\n  padding-bottom: 5px;\n  display: block;\n}\n\n.whatsapp_image {\n  display: block;\n}\n\n.subscribe__side-link {\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 24px;\n}\n\n.about__image {\n  width: auto;\n}\n\n.about__container {\n  display: block;\n}\n\n.about__columns {\n  grid-column-gap: 20px;\n  grid-row-gap: 2px;\n  justify-content: space-between;\n  align-items: flex-start;\n  display: flex;\n}\n\n.about__column-left {\n  clear: none;\n  direction: ltr;\n  flex-direction: column;\n  flex: 1;\n  order: 0;\n  justify-content: flex-start;\n  align-self: flex-start;\n  align-items: flex-start;\n  padding-left: 0;\n  display: block;\n  top: 0;\n}\n\n.about__column-right {\n  object-fit: fill;\n  flex: 0 auto;\n  order: 1;\n  align-self: flex-start;\n}\n\n.default__uupertitle {\n  color: #000;\n  padding-bottom: 20px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.default__uupertitle.center-text {\n  text-align: center;\n}\n\n.section__cookies {\n  opacity: .95;\n  -webkit-backdrop-filter: blur(9px);\n  backdrop-filter: blur(9px);\n  background-color: #fff;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  display: none;\n  position: fixed;\n  top: auto;\n  bottom: 0%;\n  left: 0%;\n  right: 0%;\n}\n\n.cookies__text {\n  justify-content: center;\n  align-items: flex-start;\n  font-size: 14px;\n  line-height: 24px;\n  display: block;\n}\n\n.cookies__container {\n  justify-content: space-around;\n  align-items: center;\n  display: flex;\n}\n\n.cookies__button {\n  width: auto;\n  grid-column-gap: 16px;\n  grid-row-gap: 16px;\n  color: #fff;\n  -webkit-text-fill-color: inherit;\n  mix-blend-mode: normal;\n  background-color: #009db7;\n  background-clip: border-box;\n  border-radius: 24px;\n  flex: 0 auto;\n  grid-template-rows: auto auto;\n  grid-template-columns: 1fr 1fr;\n  grid-auto-columns: 1fr;\n  align-items: center;\n  padding: 10px 20px;\n  font-size: 12px;\n  line-height: 14px;\n  text-decoration: none;\n  display: flex;\n}\n\n.cookies__button:hover {\n  color: #fff;\n}\n\n.cookies__button.button__subscribe-link {\n  width: 375px;\n  height: 50px;\n  border-radius: 70px;\n  padding-top: 0;\n  padding-bottom: 0;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, .2);\n}\n\n.cookies__button.button__subscribe-link.subscribe__teacher {\n  display: none;\n  position: absolute;\n  top: -2%;\n  bottom: auto;\n  left: 36%;\n  right: auto;\n}\n\n.cookies__button.menu__button {\n  letter-spacing: 1px;\n  padding: 12px 25px;\n  font-weight: 600;\n}\n\n.cookies__button.menu__button:hover {\n  color: #fff;\n}\n\n.form__group {\n  margin-bottom: 0;\n  padding-top: 5px;\n  padding-bottom: 20px;\n  position: relative;\n}\n\n.form__group.form__group-button {\n  justify-content: flex-start;\n  align-items: center;\n  padding-top: 30px;\n  padding-bottom: 30px;\n  display: flex;\n}\n\n.form__group.form__group-button.form__group__button_banner {\n  justify-content: center;\n  padding-top: 5px;\n  padding-bottom: 0;\n}\n\n.form__group.form__group-banner {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.form__label {\n  color: #333;\n  letter-spacing: 0;\n  text-transform: none;\n  margin-bottom: 5px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 14px;\n}\n\n.form__label.form__banner-label {\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.form__input {\n  height: 57px;\n  border: 0 solid #000;\n  border-radius: 10px;\n  font-size: 12px;\n}\n\n.form__input.form__banner-input {\n  height: 45px;\n  border-bottom-width: 1px;\n  border-radius: 0;\n}\n\n.checkbox-label {\n  letter-spacing: 0;\n  text-transform: none;\n  margin-left: 15px;\n  font-size: 16px;\n  line-height: 24px;\n  text-decoration: none;\n}\n\n.checkbox-label.checkbox__label-banner {\n  font-size: 12px;\n  line-height: 16px;\n}\n\n.form__check {\n  align-items: center;\n  display: flex;\n}\n\n.submit-button {\n  width: 112px;\n  height: 38px;\n  letter-spacing: 1px;\n  background-color: #009db7;\n  border-radius: 24px;\n  padding-left: 20px;\n  padding-right: 20px;\n  font-size: 11px;\n  font-weight: 800;\n  line-height: 14px;\n  display: block;\n}\n\n.form__grid {\n  grid-template-rows: auto;\n  grid-template-columns: 1fr .5fr;\n}\n\n.form__grid.form__grid-all {\n  grid-row-gap: 5px;\n  grid-template-columns: 1fr;\n}\n\n.banner__menu {\n  z-index: 10;\n  width: 100%;\n  height: auto;\n  grid-column-gap: 40px;\n  background-color: rgba(0, 0, 0, 0);\n  justify-content: flex-start;\n  align-items: flex-end;\n  margin-top: 50px;\n  display: flex;\n  position: absolute;\n}\n\n.banner__menu_container {\n  grid-column-gap: 25px;\n  align-self: center;\n  align-items: center;\n  display: flex;\n}\n\n.menu__link {\n  color: #fff;\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 24px;\n  text-decoration: none;\n}\n\n.menu__link:hover {\n  color: #fff;\n}\n\n.banner__info {\n  width: 100%;\n  justify-content: center;\n  align-self: auto;\n  align-items: center;\n  display: flex;\n  position: absolute;\n  top: 19%;\n  bottom: 0%;\n  left: 0%;\n  right: auto;\n}\n\n.banner__info-uppertitle {\n  width: auto;\n  float: none;\n  clear: none;\n  color: #000;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  column-count: auto;\n  white-space: normal;\n  -webkit-text-fill-color: inherit;\n  object-fit: fill;\n  background-color: rgba(0, 0, 0, 0);\n  background-clip: border-box;\n  border: 0 #fff;\n  border-radius: 0;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 0;\n  font-size: 10px;\n  font-weight: 800;\n  line-height: 10px;\n  display: inline-block;\n  overflow: visible;\n}\n\n.banner__info-uppertitle.banner-info-dates {\n  color: #009db7;\n  background-color: #fff;\n  margin-left: 0;\n  margin-right: 0;\n  font-weight: 400;\n  display: block;\n}\n\n.banner__info-uppertitle.banner-info-dates.info-transparent {\n  color: #fff;\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.banner__info-uppertitle.text-center {\n  text-align: center;\n}\n\n.banner__info-title {\n  color: #000;\n  padding-top: 0;\n  padding-bottom: 0;\n  font-size: 48px;\n  font-weight: 800;\n  line-height: 50px;\n}\n\n.banner__info-description {\n  color: #000;\n  margin-top: 20px;\n  padding-top: 0;\n  padding-bottom: 0;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n}\n\n.banner__info-content {\n  grid-column-gap: 20px;\n  grid-row-gap: 0px;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-top: 10px;\n  padding-top: 0;\n  display: flex;\n}\n\n.banner__info-block {\n  width: 35%;\n}\n\n.button__subscribe {\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 24px;\n}\n\n.section__student-title {\n  color: #009db7;\n  margin-bottom: 15px;\n  font-size: 32px;\n  font-weight: 800;\n  line-height: 30px;\n}\n\n.banner__info-title strong{\n  color: #009db7 !important\n}\n\n.section__student-title.form__title {\n  border-right: 0 solid #e1e1e1;\n  line-height: 44px;\n}\n\n.text-block-13 {\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.image-21 {\n  position: absolute;\n  top: 0%;\n  bottom: auto;\n  left: auto;\n  right: 0%;\n}\n\n.teacher__content {\n  width: 100%;\n  flex-direction: column;\n  align-items: flex-start;\n  padding-bottom: 20px;\n  padding-left: 25px;\n  padding-right: 25px;\n  display: flex;\n}\n\n.section__testimonial {\n  white-space: normal;\n  background-color: #f4f1e1;\n  padding-top: 100px;\n  padding-bottom: 100px;\n  position: relative;\n}\n\n.testimonial__box {\n  display: flex;\n}\n\n.testimonail__content {\n  width: 54%;\n  margin-left: 40px;\n  position: relative;\n}\n\n.testomial__description {\n  z-index: 2;\n  color: #000;\n  -webkit-text-fill-color: inherit;\n  background-color: #f4f1e1;\n  background-clip: border-box;\n  margin-left: auto;\n  margin-right: auto;\n  font-size: 14px;\n  line-height: 20px;\n  display: inline-block;\n  position: relative;\n  overflow: visible;\n}\n\n.testomial__title {\n  color: #009db7;\n  margin-top: 20px;\n  font-size: 24px;\n  font-weight: 800;\n  line-height: 36px;\n}\n\n.testomial__position {\n  color: #009db7;\n  font-size: 14px;\n  font-weight: 800;\n  line-height: 20px;\n}\n\n.testomial__link {\n  direction: ltr;\n  color: #fff;\n  letter-spacing: .48px;\n  background-color: #009db7;\n  border-radius: 24px;\n  margin-top: 20px;\n  padding: 10px 30px;\n  font-size: 12px;\n  line-height: 14px;\n  text-decoration: none;\n  display: inline-block;\n}\n\n.testomial__link:hover {\n  color: #fff;\n}\n\n.image-22 {\n  width: 208px;\n  height: 208px;\n}\n\n.image-23 {\n  z-index: 1;\n  position: absolute;\n  top: -15%;\n  bottom: auto;\n  left: -5%;\n  right: auto;\n}\n\n.image-24 {\n  z-index: 1;\n  position: absolute;\n  top: 55px;\n  bottom: 0%;\n  left: auto;\n  right: -5%;\n}\n\n.image-25 {\n  position: absolute;\n  top: auto;\n  bottom: 0%;\n  left: auto;\n  right: -2%;\n}\n\n.section__form {\n  background-color: #f4f1e1;\n  padding-top: 60px;\n  padding-bottom: 60px;\n  display: none;\n}\n\n.form__columns {\n  display: block;\n}\n\n.form__column-left {\n  border-right: 1px solid #e1e1e1;\n  border-radius: 0;\n  padding-left: 0;\n  padding-right: 40px;\n}\n\n.form {\n  -webkit-backdrop-filter: blur(9px);\n  backdrop-filter: blur(9px);\n  display: block;\n}\n\n.checkbox {\n  width: auto;\n  margin-top: 0;\n}\n\n.link {\n  color: #009db7;\n  -webkit-text-stroke-color: #009db7;\n  display: inline-block;\n}\n\n.form__column-right {\n  padding-left: 40px;\n}\n\n.form__banner {\n  width: 368px;\n  opacity: .9;\n  background-color: #fff;\n  border-radius: 12px;\n  margin-right: 0;\n  padding: 26px 35px;\n  position: absolute;\n  top: -4%;\n  bottom: auto;\n  left: auto;\n  right: 10%;\n}\n\n.form_banner-title {\n  color: #009db7;\n  padding-bottom: 20px;\n  padding-right: 0;\n  font-size: 20px;\n  font-weight: 800;\n  line-height: 24px;\n}\n\n.header_-fixed-menu {\n  z-index: 2;\n  height: 60px;\n  background-color: #fff;\n  align-items: center;\n  padding-top: 0;\n  padding-bottom: 0;\n  display: none;\n  position: fixed;\n  top: 0%;\n  bottom: auto;\n  left: 0%;\n  right: 0%;\n}\n\n.header__fixed-content {\n  grid-column-gap: 30px;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  position: relative;\n}\n\n.header__fixed-link {\n  color: #000;\n  text-transform: none;\n  align-self: auto;\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 14px;\n  text-decoration: none;\n}\n\n.section__certification {\n  background-color: #f4f1e1;\n  justify-content: center;\n  padding-top: 100px;\n  padding-bottom: 100px;\n  display: flex;\n  position: relative;\n}\n\n.certification__items {\n  width: 79%;\n  grid-column-gap: 16px;\n  grid-row-gap: 16px;\n  grid-template-rows: auto;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  grid-auto-columns: 1fr;\n  justify-content: space-between;\n  align-items: center;\n  justify-items: center;\n  display: grid;\n}\n\n.certification__item {\n  text-align: center;\n  flex-direction: column;\n  align-items: center;\n  display: flex;\n}\n\n.certification__icon-box {\n  width: 133px;\n  height: 133px;\n  background-color: #f5f4ee;\n  border-radius: 50%;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n}\n\n.certification__text {\n  padding-top: 20px;\n  line-height: 24px;\n}\n\n.image-30 {\n  width: auto;\n  height: auto;\n}\n\n.image-32 {\n  position: absolute;\n  top: -29%;\n  bottom: auto;\n  left: 0%;\n  right: auto;\n}\n\n.bold-text-2 {\n  display: inline;\n}\n\n.link-2 {\n  color: #009688;\n  display: inline;\n}\n\n.abs_bubble.bubble_module {\n  position: absolute;\n  top: auto;\n  bottom: 0%;\n  left: 0%;\n  right: auto;\n}\n\n.subscribe__box-white-title {\n  color: #009db7;\n  white-space: normal;\n  font-weight: 800;\n}\n\n.subscribe__right-column {\n  flex: 1;\n  padding-left: 10px;\n}\n\n.subscribe__box {\n  width: 100%;\n  height: 250px;\n  clear: none;\n  grid-column-gap: 0px;\n  grid-row-gap: 7px;\n  object-fit: fill;\n  background-color: #fff;\n  border-radius: 10px;\n  flex-direction: column;\n  flex: 0 auto;\n  order: 0;\n  justify-content: flex-start;\n  align-self: center;\n  align-items: flex-start;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 40px 25px 25px;\n  display: flex;\n  position: relative;\n  left: 0;\n  right: 0;\n}\n\n.subscribe__boxes {\n  grid-column-gap: 20px;\n  grid-row-gap: 16px;\n  grid-template-rows: auto;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-auto-columns: 1fr;\n  justify-content: space-between;\n  margin-top: 20px;\n  display: grid;\n}\n\n.link-3 {\n  width: 205px;\n  height: 62px;\n  color: #009db7;\n  -webkit-text-stroke-color: #009db7;\n  mix-blend-mode: normal;\n  object-fit: fill;\n  background-color: #fff;\n  border-radius: 41px;\n  justify-content: center;\n  align-items: center;\n  margin-top: 35px;\n  margin-bottom: 35px;\n  padding-top: 0;\n  padding-bottom: 0;\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 28px;\n  text-decoration: none;\n  display: flex;\n  position: static;\n  overflow: visible;\n}\n\n.link-3:hover {\n  color: #009db7;\n}\n\n.subscribe__box-title {\n  color: #000;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  white-space: normal;\n  margin-top: 0;\n  padding-top: 0;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 32px;\n}\n\n.subscribe__subtitle {\n  color: #fff;\n  text-align: center;\n  background-color: rgba(0, 0, 0, 0);\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.subscribe__subtitle.subscribe__normal-text {\n  text-align: left;\n  font-size: 24px;\n  font-weight: 800;\n  line-height: 36px;\n}\n\n.subscribe__box-white {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 12px;\n  margin-top: 20px;\n  padding: 30px 40px;\n}\n\n.section__subscribe {\n  -webkit-text-fill-color: inherit;\n  background-color: #009db7;\n  background-image: url('../../../public/assets/images/Grupo-6495.png');\n  background-position: 0 0;\n  background-size: auto;\n  background-clip: border-box;\n  padding-top: 40px;\n  padding-bottom: 40px;\n  position: relative;\n}\n\n.subscribe__box-white-text {\n  color: #000;\n}\n\n.subscribe__container {\n  max-width: 100%;\n  flex-direction: column;\n  display: flex;\n}\n\n.subscribe__box-subtitle {\n  color: #000;\n  font-size: 14px;\n  line-height: 21px;\n}\n\n.subscribe__left-column {\n  flex: 1;\n}\n\n.subscribe__investment-title {\n  color: #fff;\n  margin-bottom: 25px;\n  font-size: 32px;\n  font-weight: 800;\n}\n\n.subscribe__investment-box {\n  margin-top: 20px;\n}\n\n.subscribe__columns {\n  width: 100%;\n  grid-column-gap: 0px;\n  grid-row-gap: 0px;\n  object-fit: fill;\n  border-bottom: 0 solid #000;\n  justify-content: space-between;\n  align-self: auto;\n  margin-top: 40px;\n  margin-left: 0;\n  margin-right: 0;\n  display: flex;\n}\n\n.subscribe__box-image {\n  width: auto;\n  height: auto;\n}\n\n.subscribe__box-image.image-pre-requisites {\n  margin-bottom: 5px;\n  padding-top: 5px;\n}\n\n.bold-text-3 {\n  font-size: 24px;\n  font-weight: 800;\n  line-height: 22px;\n}\n\n.subscribe__uppertext {\n  color: #fff;\n  letter-spacing: 2px;\n  font-size: 10px;\n  font-weight: 800;\n  line-height: 32px;\n}\n\n.subscribe__payments {\n  color: #fff;\n  font-weight: 300;\n  line-height: 24px;\n}\n\n.image-33 {\n  flex: 0 auto;\n  align-self: auto;\n  margin-left: 0;\n  margin-right: auto;\n}\n\n.text-span {\n  color: #009db7;\n}\n\n.default_title {\n  color: #009db7;\n  font-size: 32px;\n  font-weight: 800;\n  line-height: 44px;\n  margin-bottom: 10px;\n}\n\n.courses_filter-container {\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 40px;\n  padding-left: 100px;\n  padding-right: 100px;\n  display: flex;\n}\n\n.courses_form-filter {\n  width: 100%;\n  position: relative;\n}\n.search-icon{\n  position: absolute;\n  top: 10px;\n}\n\n.form-filter-input {\n  color: #000;\n  background-color: rgba(0, 0, 0, 0);\n  border: 0 solid #000;\n  border-bottom: 1px solid #009db7;\n  font-size: 14px;\n  line-height: 20px;\n  padding-left: 30px;\n}\n\n.course-item-columns {\n  justify-content: space-between;\n  align-self: stretch;\n  margin-left: 0;\n  margin-right: 0;\n  display: flex;\n}\n\n.item-left-column {\n  grid-column-gap: 0px;\n  grid-row-gap: 0px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  display: flex;\n}\n\n.item-right-column {\n  flex-flow: column;\n  flex: 0 auto;\n  align-items: flex-start;\n  display: flex;\n}\n\n.course-title {\n  padding-right: 0;\n  font-size: 27px;\n  font-weight: 800;\n  line-height: 30px;\n  margin-bottom: 40px;\n}\n.course-text{\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #edecec;\n  text-align: center;\n  padding-left: 80px;\n}\n\n.course-buttons-box {\n  justify-content: space-between;\n  display: flex;\n}\n\n.course-default-button {\n  color: #1a1b1f;\n  text-transform: uppercase;\n  border: 1px solid #000;\n  border-radius: 24px;\n  padding: 10px 20px;\n  font-size: 12px;\n  font-weight: 800;\n  text-decoration: none;\n  display: inline-block;\n  transition: 0.3s all;\n  cursor: pointer;\n}\n\n.course-default-button.alt-button {\n  color: #009db7;\n  border-color: #009db7;\n  line-height: 14px;\n}\n\n.course-default-button.alt-button:hover {\n  background: #009db7;\n  color: #fff;\n}\n\n.course-default-button.default-button {\n  color: #fff;\n  background-color: #009db7;\n  border-color: #009db7;\n  line-height: 14px;\n}\n\n.course-default-button.default-button:hover {\n  color: #009db7;\n  background-color: #fff;\n}\n\n.course-default-button.secondary-button {\n  color: #fff;\n  background-color: #b1965f;\n  border-color: #b1965f;\n  line-height: 14px;\n}\n\n.course-default-button.secondary-button :hover {\n  color: #b1965f;\n  background-color: #fff;\n}\n\n.course-date-box {\n  grid-column-gap: 5px;\n  display: flex;\n}\n\n.course-date {\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.course-investment-box {\n  border-top: 1px solid #edecec;\n  margin-top: 15px;\n  padding-top: 15px;\n}\n\n.course__old-price {\n  color: #000;\n  line-height: 24px;\n  text-decoration: line-through;\n  white-space: pre-line;\n}\n\n.course_price {\n  color: #009db7;\n  font-size: 48px;\n  font-weight: 800;\n  line-height: 50px;\n  white-space: pre-line;\n}\n\n.course_discount {\n  color: #009db7;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.superscript {\n  font-size: 27px;\n}\n\n.image-34 {\n  width: 17px;\n  height: 20px;\n}\n\n.course_info-box {\n  width: 80%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  height: 100%;\n  position: relative;\n}\n\n.course_load-more-box {\n  justify-content: center;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  display: flex;\n}\n\n.course_category-section {\n  margin-bottom: 50px;\n}\n\n.form__block {\n  padding-top: 40px;\n}\n\n.modal__header {\n  width: 100%;\n  background-color: #f5f4ee;\n  border-radius: 12px;\n  padding-left: 40px;\n  padding-right: 40px;\n  position: relative;\n}\n\n.modal__content {\n  width: 50%;\n  height: auto;\n  opacity: 1;\n  color: #000;\n  -webkit-text-fill-color: inherit;\n  mix-blend-mode: normal;\n  object-fit: fill;\n  background-color: #f5f4ee;\n  background-clip: border-box;\n  border-radius: 12px;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  margin-top: 0%;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 0;\n  padding-right: 0;\n  display: flex;\n  position: relative;\n  overflow: visible;\n}\n\n.form__group-2 {\n  margin-bottom: 0;\n  padding-top: 5px;\n  padding-bottom: 10px;\n  position: relative;\n}\n\n.form__group-2.form__group-button {\n  justify-content: center;\n  align-items: center;\n  padding-top: 30px;\n  padding-bottom: 30px;\n  display: flex;\n}\n\n.modal__uppertitle {\n  color: #000;\n  letter-spacing: 2px;\n  margin-top: 10px;\n  margin-bottom: 0;\n  font-size: 10px;\n  font-weight: 800;\n  line-height: 32px;\n}\n\n.modal__form {\n  width: 100%;\n  -webkit-text-fill-color: inherit;\n  background-color: #fff;\n  background-clip: border-box;\n  border-radius: 12px;\n  padding-left: 40px;\n  padding-right: 40px;\n}\n\n.form__select-file {\n  background-color: #f4f1e1;\n  border-radius: 24px;\n  margin-top: 10px;\n  padding: 10px 20px;\n  font-size: 10px;\n  font-weight: 800;\n  line-height: 14px;\n  display: block;\n  position: absolute;\n  top: 0%;\n  bottom: auto;\n  left: auto;\n  right: 0%;\n}\n\n.form__label-2 {\n  letter-spacing: 0;\n  text-transform: none;\n  margin-bottom: 5px;\n  font-weight: 800;\n  line-height: 14px;\n}\n\n.checkbox-label-2 {\n  letter-spacing: 0;\n  text-transform: none;\n  line-height: 16px;\n  text-decoration: none;\n}\n\n.form__modal {\n  flex-direction: column;\n  display: block;\n}\n\n.section__modal {\n  z-index: 10;\n  width: 100%;\n  opacity: 1;\n  color: #1a1b1f;\n  background-color: rgba(0, 0, 0, .88);\n  flex-direction: row;\n  display: none;\n  position: fixed;\n  top: 0%;\n  bottom: 0%;\n  left: 0%;\n  right: 0%;\n  overflow: hidden;\n}\n\n.modal__title {\n  color: #006a99;\n  margin-top: 0;\n  margin-bottom: 20px;\n  font-size: 32px;\n  font-weight: 300;\n  line-height: 39px;\n}\n\n.form__input-2 {\n  border: 0 solid #000;\n  border-bottom-width: 1px;\n  font-size: 12px;\n}\n\n.modal__close {\n  z-index: 2;\n  width: 40px;\n  height: 40px;\n  background-color: #fff;\n  border-radius: 50%;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  margin-right: 20px;\n  padding-top: 0;\n  display: flex;\n  position: absolute;\n  top: 0%;\n  bottom: auto;\n  left: auto;\n  right: 0%;\n  cursor: pointer;\n}\n\n.modal__container {\n  width: 100%;\n  height: 100%;\n  opacity: 1;\n  white-space: normal;\n  -webkit-text-fill-color: inherit;\n  mix-blend-mode: normal;\n  background-color: #0000;\n  background-clip: border-box;\n  padding-top: 60px;\n  padding-bottom: 60px;\n  display: block;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.submit-button-2 {\n  width: 112px;\n  height: 38px;\n  letter-spacing: 1px;\n  background-color: #006a99;\n  border-radius: 24px;\n  padding-left: 20px;\n  padding-right: 20px;\n  font-size: 11px;\n  font-weight: 800;\n  line-height: 14px;\n  display: block;\n}\n\n.modal_container {\n  width: 100%;\n  padding: 40px 49px;\n  height: 600px;\n  overflow-y: scroll;\n}\n\n.modal_course-title {\n  color: #000;\n  margin-bottom: 20px;\n  font-size: 27px;\n  font-weight: 800;\n  line-height: 34px;\n}\n\n.modal_course-text {\n  line-height: 24px;\n  white-space: pre-line\n}\n\n.modal__conteudo *{\n  line-height: 24px;\n  white-space: pre-line;\n  margin-bottom: 0px;\n}\n\n.modal__conteudo ul{\n  line-height: 24px;\n  margin-top: 10px;\n}\n\n.modal__conteudo li{\n  line-height: 24px;\n  margin-bottom: 5px;\n}\n\n.modal_course-block {\n  grid-column-gap: 16px;\n  grid-row-gap: 16px;\n  grid-template-rows: auto;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-auto-columns: 1fr;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  display: block;\n}\n\n.modal_course-block.course-block-items {\n  grid-column-gap: 16px;\n  grid-row-gap: 16px;\n  grid-template-rows: auto;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-auto-columns: 1fr;\n  margin-top: 40px;\n  margin-bottom: 40px;\n  display: grid;\n}\n\n.modal_course-subtitle {\n  color: #009db7;\n  margin-bottom: 5px;\n  font-size: 20px;\n  font-weight: 800;\n  line-height: 24px;\n}\n\n.modal_course-block-item {\n  flex-direction: column;\n  display: block;\n}\n\n.course-block-icon {\n  margin-bottom: 5px;\n}\n\n.image-35 {\n  background-color: #fff;\n}\n\n.section__modal {\n  display: block;\n}\n\n@media screen and (min-width: 1440px) {\n  .section__courses {\n    padding-top: 100px;\n    padding-bottom: 100px;\n  }\n\n  .center.banner__info-container.pos-relative {\n    position: relative;\n  }\n\n  .courses__container {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .section__teacher {\n    justify-content: center;\n    display: flex;\n  }\n\n  .selo__mec {\n    height: auto;\n  }\n\n  .section__cookies {\n    opacity: .89;\n    -webkit-backdrop-filter: blur(5px);\n    backdrop-filter: blur(5px);\n    background-color: #fff;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    position: fixed;\n    top: auto;\n    bottom: 0%;\n    left: 0%;\n    right: 0%;\n  }\n\n  .cookies__text {\n    z-index: 2;\n    color: #000;\n    object-fit: fill;\n    font-size: 14px;\n    line-height: 24px;\n    position: relative;\n  }\n\n  .cookies__container {\n    z-index: auto;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    display: flex;\n    position: relative;\n  }\n\n  .cookies__button {\n    color: #fff;\n    letter-spacing: .48px;\n    background-color: #009db7;\n    border-radius: 24px;\n    padding: 10px 20px;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 14px;\n    text-decoration: none;\n  }\n\n  .cookies__button.button__subscribe-link.subscribe__teacher {\n    left: auto;\n    right: auto;\n  }\n\n  .form__grid {\n    grid-column-gap: 36px;\n    grid-row-gap: 16px;\n  }\n\n  .banner__desktop-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    min-height: 600px;\n  }\n\n  .button__subscribe {\n    font-size: 15px;\n  }\n\n  .banner__info{\n    height: 65%;\n  }\n\n  .form__banner {\n    right: 0%;\n  }\n\n  .section__certification {\n    justify-content: center;\n    display: flex;\n  }\n\n\n}\n\n@media screen and (max-width: 991px) {\n  .section__courses {\n    padding-top: 10px;\n    padding-bottom: 60px;\n  }\n\n  .section__courses.cc-cta {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .center {\n    padding-left: 40px;\n    padding-right: 40px;\n  }\n\n  .center.center__inner {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .button {\n    justify-content: center;\n  }\n\n  .button.cc-contact-us {\n    display: none;\n  }\n\n  .heading-jumbo {\n    font-size: 56px;\n    line-height: 70px;\n  }\n\n  .logo-link.w--current {\n    flex: 1;\n  }\n\n  .menu-icon {\n    display: block;\n  }\n\n  .menu {\n    margin-left: 30px;\n    position: static;\n  }\n\n  .navigation-wrap {\n    background-color: #fff;\n  }\n\n  .navigation {\n    padding: 25px 30px;\n  }\n\n  .navigation-item {\n    text-align: center;\n    padding: 15px 30px;\n    transition: background-color .4s, opacity .4s, color .4s;\n  }\n\n  .navigation-item:hover {\n    background-color: #f7f8f9;\n  }\n\n  .navigation-item:active {\n    background-color: #eef0f3;\n  }\n\n  .menu-button {\n    padding: 0;\n  }\n\n  .menu-button.w--open {\n    background-color: rgba(0, 0, 0, 0);\n  }\n\n  .navigation-items {\n    background-color: #fff;\n  }\n\n  .cta-text {\n    width: auto;\n  }\n\n  .cta-wrap {\n    width: auto;\n    padding: 80px 50px 90px;\n  }\n\n  .blog-detail-header-wrap {\n    width: 70%;\n  }\n\n  .detail-header-image {\n    height: 460px;\n  }\n\n  .title__center {\n    overflow: visible;\n  }\n\n  .courses__container {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .section__teacher {\n    justify-content: center;\n    align-items: stretch;\n  }\n\n  .teacher__container {\n    display: block;\n  }\n\n  .teacher__grid {\n    z-index: 2;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    align-content: stretch;\n    justify-content: center;\n    justify-items: center;\n    position: relative;\n  }\n\n  .selo__mec {\n    width: auto;\n    height: auto;\n  }\n\n  .footer_columns {\n    grid-row-gap: 25px;\n    flex-direction: column-reverse;\n    display: flex;\n  }\n\n  .footer__column-logo {\n    justify-content: center;\n    align-self: center;\n    display: flex;\n  }\n\n  .footer_column-content {\n    align-self: center;\n  }\n\n  .footer__social-media {\n    width: 100%;\n  }\n\n  .section__banner {\n    height: 770px;\n  }\n\n  .about__image {\n    width: 100%;\n  }\n\n  .about__columns {\n    flex-direction: column;\n  }\n\n  .about__column-left {\n    align-self: auto;\n    padding-bottom: 40px;\n  }\n\n  .cookies__button.button__subscribe-link.subscribe__teacher {\n    top: -24px;\n    left: auto;\n  }\n\n  .form__group {\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n\n  .form__grid {\n    grid-template-rows: auto;\n    grid-template-columns: 1fr;\n  }\n\n  .banner__menu_container {\n    display: none;\n  }\n\n  .banner__desktop-image {\n    width: auto;\n    height: 770px;\n    object-fit: cover;\n  }\n\n  .banner__info {\n    margin-top: 0;\n  }\n\n  .banner__info-block {\n    width: 56%;\n  }\n\n  .image-24 {\n    top: 65px;\n    right: -9%;\n  }\n\n  .image-25.abs_bubble,\n  .form__banner,\n  .header_-fixed-menu {\n    display: none;\n  }\n\n  .certification__items {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .image-32 {\n    display: none;\n  }\n\n  .subscribe__right-column {\n    padding-bottom: 40px;\n    padding-left: 0;\n  }\n\n  .subscribe__columns {\n    flex-direction: column-reverse;\n    display: flex;\n  }\n\n  .bold-text-4 {\n    font-size: 25px;\n    line-height: 28px;\n  }\n\n  .form__group-2 {\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n\n  .form__select-file {\n    position: static;\n  }\n\n  .modal__title {\n    font-size: 25px;\n    line-height: 26px;\n  }\n\n  .form__grid-2 {\n    grid-template-rows: auto;\n    grid-template-columns: 1fr;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .section__courses {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  .section__courses.cc-cta {\n    padding: 15px;\n  }\n\n  .center {\n    text-align: center;\n  }\n\n  .center.banner__info-container {\n    text-align: left;\n  }\n\n  .paragraph-bigger {\n    font-size: 16px;\n    line-height: 28px;\n  }\n\n  .rich-text {\n    width: 90%;\n    max-width: 470px;\n    text-align: left;\n  }\n\n  .heading-jumbo {\n    font-size: 50px;\n    line-height: 64px;\n  }\n\n  .heading-jumbo-small {\n    font-size: 30px;\n    line-height: 52px;\n  }\n\n  .logo-link {\n    padding-left: 0;\n  }\n\n  .navigation {\n    padding: 20px 30px;\n  }\n\n  .cta-wrap {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n\n  .blog-detail-header-wrap {\n    width: 90%;\n    max-width: 470px;\n    text-align: left;\n  }\n\n  .utility-page-wrap {\n    padding: 15px;\n  }\n\n  ._404-wrap {\n    padding: 30px;\n  }\n\n  .courses__container {\n    width: 100%;\n    padding-top: 10px;\n  }\n\n  .modules__item-title {\n    flex: none;\n  }\n\n  .modules__subtitle {\n    text-align: left;\n  }\n\n  .bold-text {\n    font-size: 20px;\n  }\n\n  .dpo__columns {\n    grid-row-gap: 21px;\n    flex-direction: column;\n    justify-content: flex-start;\n  }\n\n  .dpo__left-column {\n    text-align: center;\n  }\n\n  .dpo__right-column {\n    flex: 0 auto;\n    justify-content: center;\n    align-self: center;\n    align-items: center;\n    display: flex;\n  }\n\n  .dpo__title {\n    text-align: center;\n  }\n\n  .selo__mec {\n    width: auto;\n    height: auto;\n    display: block;\n  }\n\n  .section__footer {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .footer__social-media {\n    grid-row-gap: 25px;\n    flex-direction: column;\n    align-items: center;\n    display: flex;\n  }\n\n  .social__whatsapp {\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    display: flex;\n  }\n\n  .social__faleconosco {\n    grid-row-gap: 0px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n  }\n\n  .social__follow {\n    flex-direction: column;\n    align-items: center;\n    display: flex;\n  }\n\n  .section__about {\n    padding-bottom: 10px;\n  }\n\n  .default__uupertitle,\n  .cookies__text {\n    text-align: left;\n  }\n\n  .banner__info-block {\n    width: 90%;\n  }\n\n  .text-block-13 {\n    text-align: left;\n  }\n\n  .section__certification {\n    padding-top: 40px;\n  }\n\n  .subscribe__box-white-title {\n    text-align: left;\n  }\n\n  .link-3 {\n    flex-direction: row;\n    justify-content: center;\n    align-self: center;\n    align-items: center;\n    display: flex;\n  }\n\n  .subscribe__subtitle.subscribe__normal-text {\n    text-align: left;\n    font-size: 15px;\n  }\n\n  .subscribe__box-white-text {\n    text-align: left;\n  }\n\n  .subscribe__left-column {\n    flex-direction: column;\n    align-self: auto;\n    display: flex;\n  }\n\n  .subscribe__columns {\n    align-self: auto;\n  }\n\n  .bold-text-4 {\n    font-size: 21px;\n  }\n\n  .modal__title {\n    font-size: 19px;\n  }\n  .course-text{\n    padding-left: 0px;\n  }\n  \n}\n\n@media screen and (max-width: 479px) {\n  h1 {\n    font-size: 36px;\n    line-height: 52px;\n  }\n\n  .section__courses {\n    padding-top: 40px;\n  }\n\n  .center {\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .rich-text {\n    width: 100%;\n    max-width: none;\n  }\n\n  .heading-jumbo {\n    font-size: 36px;\n    line-height: 48px;\n  }\n\n  .menu {\n    margin-left: 15px;\n  }\n\n  .navigation {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .menu-button,\n  .menu-button.w--open {\n    flex: none;\n  }\n\n  .cta-wrap {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n\n  .blog-detail-header-wrap {\n    width: 100%;\n    max-width: none;\n  }\n\n  .section-heading {\n    font-size: 24px;\n    line-height: 24px;\n  }\n\n  .title__center {\n    margin-top: 40px;\n    padding-top: 0;\n    font-size: 26px;\n    line-height: 28px;\n  }\n\n  .courses__container {\n    width: 100%;\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .course-item-box {\n    flex-direction: column;\n    align-items: center;\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .modules__item-title {\n    font-size: 17px;\n  }\n\n  .modules__subtitle {\n    text-align: center;\n    font-size: 16px;\n    line-height: 17px;\n  }\n\n  .bold-text {\n    align-items: center;\n    font-size: 18px;\n  }\n\n  .modules__icon {\n    display: none;\n  }\n\n  .modules__item-header {\n    flex-direction: column;\n  }\n\n  .section__teacher {\n    padding-bottom: 60px;\n  }\n\n  .subscribe__module-title {\n    text-align: center;\n    font-size: 34px;\n    line-height: 40px;\n  }\n\n  .teacher__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .dpo__description {\n    text-align: center;\n    line-height: 17px;\n  }\n\n  .selo__mec {\n    height: auto;\n  }\n\n  .header__container {\n    justify-content: center;\n  }\n\n  .header__link {\n    display: block;\n  }\n\n  .section__banner {\n    width: 100%;\n    height: 500px;\n  }\n\n  .section__about {\n    padding-top: 40px;\n    padding-bottom: 40px;\n  }\n\n  .sidebar {\n    display: none;\n  }\n\n  .about__column-left {\n    padding-bottom: 10px;\n  }\n\n  .default__uupertitle {\n    font-size: 15px;\n    line-height: 24px;\n  }\n\n  .default__uupertitle.center-text {\n    text-align: center;\n  }\n\n  .section__cookies {\n    display: none;\n  }\n\n  .cookies__text {\n    text-align: center;\n  }\n\n  .cookies__container {\n    grid-row-gap: 19px;\n    text-align: center;\n    flex-direction: column;\n  }\n\n  .cookies__button.button__subscribe-link {\n    width: 334px;\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    text-align: left;\n    object-fit: fill;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: center;\n    align-self: auto;\n    display: flex;\n  }\n\n  .cookies__button.button__subscribe-link.subscribe__teacher {\n    width: 88%;\n    display: none;\n  }\n\n  .form__group {\n    text-align: left;\n    padding-bottom: 0;\n  }\n\n  .form__group.form__group-button {\n    text-align: left;\n    justify-content: center;\n    padding-top: 10px;\n  }\n\n  .form__label {\n    margin-bottom: 0;\n    padding-bottom: 10px;\n  }\n\n  .submit-button.form__submit {\n    width: 100%;\n  }\n\n  .banner__menu {\n    height: 150px;\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    flex-direction: column-reverse;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: center;\n    align-items: flex-start;\n    margin-top: 10px;\n    padding-left: 20px;\n    display: flex;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: auto;\n  }\n\n  .banner__desktop-image {\n    filter: brightness();\n    -webkit-text-fill-color: inherit;\n    background-color: rgba(0, 0, 0, 0);\n    background-clip: border-box;\n  }\n\n  .banner__info {\n    z-index: 5;\n    top: 21%;\n  }\n\n  .banner__info-uppertitle.banner-info-dates,\n  .banner__info-uppertitle.text-center {\n    width: 100%;\n  }\n\n  .banner__info-title {\n    font-size: 31px;\n    line-height: 33px;\n  }\n\n  .banner__info-description {\n    font-size: 15px;\n    line-height: 23px;\n  }\n\n  .banner__info-content {\n    grid-row-gap: 10px;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n  }\n\n  .banner__info-block {\n    width: 100%;\n  }\n\n  .button__subscribe {\n    font-size: 11px;\n    line-height: 21px;\n  }\n\n  .button__subscribe-icon {\n    display: none;\n  }\n\n  .section__student-title.form__title {\n    text-align: center;\n  }\n\n  .text-block-13 {\n    text-align: left;\n  }\n\n  .image-21.abs_bubble {\n    display: none;\n  }\n\n  .section__testimonial {\n    padding-top: 60px;\n    padding-bottom: 60px;\n  }\n\n  .testimonial__box {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .testimonail__content {\n    width: 100%;\n    margin-top: 40px;\n    margin-left: 0;\n  }\n\n  .image-23 {\n    display: none;\n    top: -13%;\n    left: -9%;\n  }\n\n  .image-24 {\n    display: none;\n    top: 29%;\n  }\n\n  .section__form {\n    padding-top: 40px;\n    padding-bottom: 0;\n  }\n\n  .form__column-left {\n    padding-right: 0;\n  }\n\n  .form__column-right {\n    padding-left: 0;\n  }\n\n  .section__certification {\n    padding-top: 40px;\n    padding-bottom: 60px;\n  }\n\n  .certification__items {\n    grid-template-columns: 1fr;\n  }\n\n  .subscribe__box {\n    height: auto;\n  }\n\n  .subscribe__boxes {\n    height: auto;\n    grid-template-columns: 1fr;\n  }\n\n  .link-3 {\n    font-size: 16px;\n  }\n\n  .subscribe__subtitle.subscribe__normal-text {\n    display: none;\n  }\n\n  .subscribe__box-white {\n    flex-direction: column;\n    padding-left: 40px;\n    padding-right: 40px;\n    display: flex;\n  }\n\n  .section__subscribe {\n    padding-top: 0;\n  }\n\n  .subscribe__container {\n    flex-direction: column-reverse;\n    align-items: stretch;\n  }\n\n  .subscribe__box-subtitle {\n    text-align: left;\n  }\n\n  .subscribe__investment-title {\n    font-size: 26px;\n  }\n\n  .subscribe__columns {\n    flex-direction: column-reverse;\n  }\n\n  .logo-ens,\n  .logo-unisincor {\n    width: 200px;\n  }\n\n  .courses_filter-container {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .form-filter {\n    width: 100%;\n  }\n\n  .course-item-columns {\n    grid-column-gap: 0px;\n    grid-row-gap: 20px;\n    flex-direction: column;\n  }\n\n  .item-right-column {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .course-title {\n    text-align: left;\n  }\n\n  .course-buttons-box {\n    grid-row-gap: 10px;\n    flex-direction: column;\n  }\n\n  .course_info-box {\n    width: 100%;\n  }\n\n  .modal__content {\n    width: 90%;\n  }\n\n  .bold-text-4 {\n    font-size: 18px;\n    line-height: 17px;\n  }\n\n  .modal__uppertitle {\n    font-size: 9px;\n    line-height: 21px;\n  }\n\n  .modal__form {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .form__label-2 {\n    margin-bottom: 0;\n  }\n\n  .section__modal {\n    display: block;\n  }\n\n  .modal__title {\n    font-size: 16px;\n    line-height: 22px;\n  }\n\n  .modal__close {\n    width: 30px;\n    height: 30px;\n    line-height: 28px;\n  }\n\n  .modal_container {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .modal_course-block.course-block-items {\n    grid-template-columns: 1fr;\n  }\n\n  .modal_course-block-item {\n    align-items: center;\n    display: flex;\n  }\n}\n\n\n.fade-effect {\n  height: 40px;\n  background: transparent linear-gradient(180deg, #F4F1E100 0%, #F4F1E1CF 65%, #F4F1E1 100%) 0% 0% no-repeat padding-box;\n  width: 100%;\n  position: absolute;\n  bottom: 0px;\n\n}\n\n.footer_banner{\n  width: 100%\n}\n\n.footer_banner-image{\n  width: 100%\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
